<script>
	import Header from "./Header.svelte";
	import { push, replace } from 'svelte-spa-router'
	import { springIn, springOut } from "svelte-helpers/spring-transitions";
	import { fade } from "svelte/transition";
	import SwitchSmall from './SwitchSmall.svelte';
//	import { set_section } from "./Header.svelte";
	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	const modal = writable(null);
	const modal1 = writable(null);
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import { loader } from './loader';
	let artifact_loading = writable(true);

	const progress = tweened(0, {
		duration: 200,
		easing: cubicOut
	});

	const daily_power = tweened(0, {
		duration: 400,
		easing: cubicOut
	});

	// The params prop contains values matched from the URL
	export let params = {};

	import { Line } from 'svelte-chartjs'
	import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale } from 'chart.js';

	ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale);

	let health_data = {
	  labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
	  datasets: [ {
      label: 'Watts',
      fill: true,
      lineTension: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderColor: 'hsl(185, 97%, 75%)',
      borderCapStyle: 'butt',
      borderDash: [],
	  borderWidth: 2,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
	  pointRadius: 0,
      data: [50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50],
    },
	],
	};

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('home');

	let dash_token = params.t;
	if (dash_token != '1' && dash_token != '2' && dash_token != '') {
		setCookie("m_dash_token", dash_token, 30)
	} else {
		dash_token = getCookie('m_dash_token');
	}

	let action_id = params.action_id;

	let show_details = false;
	let show_mebots = false;
	let show_artifacts = false;
	let show_places = false;
	let show_places_today = true;
	let show_claim = false;
	let show_artifact_detail = -1;
	let show_place_detail = -1;
	let email_signup = '';

	let result = null;
	let mebot_img_url = null;
	let my_mebot_img_url = null;
	let badge_count = 0;
	let watts_score = "";
	let steps = "";
	let explorer = "";
	let social = "";
	let hrv = "";
	let sleep = "";
	let braniac = "";
	let m_id = "";
	let chain_id = 0;
	let is_hatched = 0;
	let has_egg_to_hatch_i = -1;
	let mtype = '';
	let is_hatching = 0;
	let hatched = '';
	let minted = '';
	let active_m_id = 0;
	let active_m_index = 0;
	let is_active = 0;
	let watt_level = 0;
	let user_watt_level = 0;
	let watt_level_info = '';
	let autopilot_level = 0;
	let trips = 0;
	let auto_walk = 1;
	let sparkles = 0;
	let show_close = true;
	let timeout_id;
	let mebots = [];
	let artifacts = [];
	let artifacts_tmp = [];
	let artifacts_n  = 0;
	let artifacts_uc = 0;
	let structures = [];
	let habitats = [];
	let h_sts = [];
	let h_tags = [];
	let habitat_tags = '';
	let h_settlers = [];
	let h_settlers_count = 0;
	let h_count = 0;
	let social_link = '';
	let social_qr = '';
	let qr_img_tag = '';
	let num_invites = '';
	let copied = false;

	let city_guilds = '';

	let journey = [];
	journey['info'] = '';
	journey['info_full'] = '';


	let mebot_trips = [];
	let mebot_trips_tmp = [];
	let mebot_attr = [];
	let show_mebot_trips = false;
	let show_get_app = false;
	let show_get_app_result = false;
	let trips_mebot_id = 0;
	let stat_type = 0;
	let mebot_moon_phase = 1;
	let mebot_moon_phase_days = 0;
	let mebot_total_n = '';
	let mebot_mood = '';
	let mebot_mood_desc = '';
	let mebot_14day_steps = '0';
	let mebot_14day_steps_n = 0;
	let mebot_class_id = null;
	let mebot_class_name = null;
	let can_chat = 0;
	let chat_n = '';

	let land42_id = 1;
	let filter_pl_def = 1;
	let habitat_msg = '';
	let cur_hab_id = 0;
	let cur_hab_url = '';
	let hab_visited_today = '1 habitat';
	let total_dist = '0';
	let total_dist_max = '1';
	let total_dist_in_square = '';
	let map_badge_n = 0;
	let news_badge_n = 0;
	let is_anon = 0;
	let is_alpha = 0;
	let today_n = '';
	let mebot_power = '';
	let power_avail = '';
	let battleness = '';
	let artifact_page_size = 30;
	let artifact_fetching = false;

	let steps_taken = '';
	let habitats_empty = '';
	let mayor_h_num = '';
	let badge_n = [];
	let mayor_mebot_img_url = null;
	let hab_mayor_id = 0;
	let parsecs_disp = 'parsecs';
	let claimed_habitat_name = '';
	let claimed_habitat_id = -1;
	let claimed_habitat_error = '';
	let quest_level = 0;
	let quest_streak = 0;
	let streak_completed = 0;
	let ironman_badges = 0;
	let is_mayor = 0;
	let is_settled = 0;
	let is_own = 0;
	let is_building = false;
	let frame, frame1;
	let confetti_animation = false;
	let is_balance_pulse = false;
	let should_celebrate = 0;
	let characters = ['🌟', '🎉', '✨'];
	let confetti = new Array(50).fill().map((_, i) => {
		return {
			character: characters[i % characters.length],
			x: Math.random() * 100,
			y: -20 - Math.random() * 100,
			r: 0.1 + Math.random() * 1.2
		};
	}).sort((a, b) => a.r - b.r);

	let sparklers_animation = false;
	let sparklers_found = false;
	let sparklers_chars = ['✨'];
	let sparklers = new Array(100).fill().map((_, i) => {
		return {
			character: sparklers_chars[i % sparklers_chars.length],
			x: Math.random() * 100,
			y: -20 - Math.random() * 100,
			r: 0.1 + Math.random() * 1.2
		};
	}).sort((a, b) => a.r - b.r);


	let is_fav_hab = 0;
	let liking = false;
	let can_build = 0;
	let building_id = 0;
	let is_loading = false;
	let habitat_details = -1;

	badge_count = 8;

    let page_url = '#';

	async function getLink(id) {

        console.log('page_id: ' + id)

        const res = await fetch(
            "https://api.forever.today/?method=get_page_link",
            {
                method: "POST",
                body: JSON.stringify({
                    dash_token,
                    page_id: id
                }),
            }
        );

        const json = await res.json();
        result = json;
        page_url = json.data.page_link_url;
    }

	function confetti_loop() {
		if (confetti_animation) {
			frame = requestAnimationFrame(confetti_loop);
		}

		confetti = confetti.map(emoji => {
			emoji.y += 0.7 * emoji.r;
			if (emoji.y > 120) emoji.y = -20;
			return emoji;
		});
	}

	function sparklers_loop() {
		if (sparklers_animation) {
			frame1 = requestAnimationFrame(sparklers_loop);
		}

		sparklers = sparklers.map(emoji => {
			emoji.y += 0.7 * emoji.r;
			emoji.x += 0.7 * emoji.r;
			if (emoji.y > 120) emoji.y = -20;
			if (emoji.x > 120) emoji.x = -20;
			return emoji;
		});
	}

	async function doPost() {

		let client_width = document.documentElement.clientWidth;
		console.log(client_width);

		let v_h_id = getCookie('v_h_id');
		if (v_h_id > 0 || v_h_id == -2 || v_h_id == -3) {
			show_mebots = false;
			show_places = true;
		}

		const res = await fetch(
			"https://api.forever.today/?method=get_dash_user",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					client_width
				}),
			}
		);

		const json = await res.json();
		result = json;
		social_link = json.data.social_link;
		social_qr = json.data.social_qr;

		if (social_qr != '') {
			qr_img_tag = `
			<div style="background: white; width: 34px; height: 34px; border-radius: 6px; margin-bottom: 6px;"><img src="` + social_qr + `" width=34px height=34px></div>
			`;
		}

		num_invites = json.data.num_invites;
		is_hatched = json.data.is_hatched;
		mtype = json.data.mtype;
		is_hatching = json.data.is_hatching;
		minted = json.data.minted;
		hatched = json.data.hatched;
		is_active = 1;
		mebot_img_url = json.data.mebot_img_url;
		my_mebot_img_url = mebot_img_url;
		watts_score = json.data.watts.watt_score;
		steps = json.data.watts.steps;
		explorer = json.data.watts.explorer;
		hrv = json.data.watts.hrv;
		sleep = json.data.watts.sleep;
		social = json.data.watts.social;
		braniac = json.data.watts.braniac;
		m_id = json.data.m_id;
		chain_id = json.data.chain_id;
		active_m_id = m_id;
		watt_level = json.data.md.watt_level;
		user_watt_level = json.data.watts.watt_level;
		watt_level_info = json.data.watts.watt_level_info;
		autopilot_level = json.data.md.autopilot_level;
		trips = json.data.md.trips;
		auto_walk = json.data.md.auto_walk;
		sparkles = json.data.md.sparkles;
		mebot_moon_phase = json.data.md.mp;
		mebot_moon_phase_days = json.data.md.mp_days;
		mebot_total_n = json.data.md.total_n;
		mebot_mood = json.data.md.mood;
		mebot_mood_desc = json.data.md.mood_d;
		health_data.datasets[0].data = json.data.md.health;
		quest_level = json.data.quest_level;
		quest_streak = json.data.quest_streak;
		streak_completed = json.data.streak_completed;
		ironman_badges = json.data.ironman_badges;
		should_celebrate = json.data.celebrate;

		journey = json.data.journey;

		console.log('mood ' + mebot_mood)
		mebot_14day_steps = json.data.md.steps_14day_av_info;
		mebot_14day_steps_n = json.data.md.steps_14day_av;
		progress.set(json.data.md.steps_14day_av/100)

		daily_power.set(json.data.md.dp/100);
		mebot_power = json.data.md.mebot_power;
		power_avail = json.data.md.power_avail;
	
		is_anon = json.data.is_anon;
		setCookie("is_anon", is_anon, 1);

		is_alpha = json.data.is_alpha;
		setCookie("is_alpha", is_alpha, 1);

		today_n = json.data.today_n;

		map_badge_n = getCookie("map_badge_n");
		//if (map_badge_n != 0) {
			map_badge_n = json.data.map_badge_n;
			setCookie("map_badge_n", map_badge_n, 1);
		//}

		news_badge_n = getCookie("news_badge_n");
		news_badge_n = json.data.news_badge_n;
		setCookie("news_badge_n", news_badge_n, 1);

		setCookie("mebot_img_url", mebot_img_url, 30);

		if (m_id != '') {
			setCookie("m_id", m_id, 30)
			//console.log('setting m_id cookie:' + m_id);
		}
		if (m_id == '') {
			//console.log('got m_id from cookie:' + getCookie('m_id'));
			m_id = getCookie('m_id');
		}

		loadHealthData(m_id, 0)

		if (m_id > 10000) {
			getLink(1);
		}

		land42_id = Math.floor(Math.random() * 7 + 1);
		await getHabitats(1);

		kickoffCelebrate();

		let show_balance_pulse = getCookie("balance_pulse");
		if (show_balance_pulse != 'yes') {
			is_balance_pulse = true
			setTimeout(function(){
				is_balance_pulse = false;
				setCookie("balance_pulse", 'yes', 3);
			}, 2000);
		}

		//console.log(habitats)
		if (v_h_id > 0 || v_h_id < 0) {
			// -1 is for new habitat setup

			if (v_h_id > 0) {
				await getHabitats(6);
			}

			console.log(v_h_id)
			setCookie("v_h_id", 0, 1)
			//show_place_detail = 0;
			//habitat_details = 1;
			//showPlaces();

			show_mebots = false;
			show_details = false;
			show_artifacts = false;
			show_places = true;
			show_place_detail = -1;
			habitat_details = -1;
			is_building = false;
			show_get_app = false;

			if (v_h_id > 0) {
				show_place_detail = 0;
				habitat_details = 0;
				getPlaceDetail(0);
			}

			if (v_h_id == -1) {
				if (sparkles >= 1000) {
					console.log('claim action from map')
					show_claim = false;
					processClaimAction()
				} else {
					displaySetupHabitat();
				}
			}

			if (v_h_id == -2) {
				showPlaces();
			}

			if (v_h_id == -3) {
				onShowMeGetAppAction();
			}
		}

		if (action_id == 1) {
			copySocial();
		}

		await getMyMebots();
	}

	async function favHabitat(habitat_id) {

		liking = true;
		setTimeout(function(){ liking = false; is_fav_hab = true; }, 1200);

		const res = await fetch(
			"https://api.forever.today/?method=fav_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					habitat_id
				}),
			}
		);
	}

	async function doneCelebrating(level_id) {

		const res = await fetch(
			"https://api.forever.today/?method=set_celebrate",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					level_id
				}),
			}
		);

		const json = await res.json();
		quest_streak = json.data.quest_streak;
		streak_completed = json.data.streak_completed;
	}

	async function getStructures(hab_id = 0) {

		const res = await fetch(
			"https://api.forever.today/?method=get_structures",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					hab_id
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.structures;

		structures = [];
		for (const runner of runners) {
			structures.push({
				id: runner.id,
				name: runner.name,
				short_name: runner.short_name,
				em: runner.em,
				cost: runner.cost,
				class: runner.class,
				is_built: runner.is_built
			});
		}
	}

	async function refreshSparkles() {

		let client_width = document.documentElement.clientWidth;

		const res = await fetch(
			"https://api.forever.today/?method=get_dash_user",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					client_width
				}),
			}
		);
		const json = await res.json();
		sparkles = json.data.md.sparkles;
	}

	async function loadHealthData(mebot_id, stat_type_id = -1) {

		if (stat_type_id == -1) {
            stat_type += 1;
		} else {
            stat_type = stat_type_id;
		}

		if (stat_type > 6) {
		    stat_type = 0;
		}

		let res = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
                stat_type
            })
		})

        let json = await res.json()
		health_data.datasets[0].data = json.data.mebot.health;

		mebot_class_id = json.data.mebot.class_id;
		mebot_class_name = json.data.mebot.class;
		can_chat = json.data.mebot.c_c;
		chat_n = json.data.mebot.c_n;
		//battleness = json.data.mebot.b_i;

	}

	async function getArtifacts(offset = -1) {

		if (offset > 0 && artifacts_uc <= artifacts.length) {
			//reached end of all available artifacts
			return;
		}

		if (m_id > 0) {

		console.log('getting artifacts, offset: ' + offset)
		artifact_fetching = true;
		artifact_loading.update(n => artifact_fetching);

		let res = await fetch(
			"https://api.forever.today/?method=get_artifacts",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					offset,
				}),
			}
		);

		let json = await res.json();
		let runners = json.data.artifacts;
		let ii = 0;
		artifacts_tmp = [];
		for (const runner of runners) {
			artifacts_tmp.push({
				    id: runner.id,
					em: runner.em,
					n: runner.n,
					title: runner.name,
					desc: runner.desc,
					v: runner.v,
					sell: runner.sell
			});
			//ii = ii + runner.n;
		}

		if (offset == -1) {
			artifacts = artifacts_tmp;
			article_n = 0;

		} else {
			//append
			artifacts = artifacts.concat(artifacts_tmp);
		}

		artifacts_n = json.data.n;
		artifacts_uc = json.data.uc;
		//artifacts.push({em: '🎧', n: 1});
		//artifacts.push({em: '🥄', n: 7});
		//artifacts.push({em: '🥊', n: 3});
		//artifacts.push({em: '〇', n: 3});
		//artifacts.push({em: '🛸', n: 1});
		//artifacts.push({em: '🚀', n: 2});

		artifact_fetching = false;
		artifact_loading.update(n => artifact_fetching);
		}
	}

	async function getMyMebots() {

		let res = await fetch(
			"https://api.forever.today/?method=get_mebots",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
				}),
			}
		);

		let json = await res.json();
		let runners = json.data.mebots;
		let ii = 0;

		mebots = [];
		for (const runner of runners) {
			mebots.push({
				id: runner.m_id,
				img: runner.mebot_img_url,
				is_hatched: runner.md.is_hatched,
				chain_id: runner.md.chain_id,
				mtype: runner.md.mtype,
				is_hatching: runner.md.is_hatching,
				is_active: runner.md.is_active,
				minted: runner.md.minted,
				hatched: runner.md.hatched,
				watt_level: runner.md.watt_level,
				autopilot_level: runner.md.autopilot_level,
				trips: runner.md.trips,
				auto_walk: runner.md.auto_walk,
				byline: runner.md.byline,
				badges: runner.md.badges,
			});
			if (runner.m_id < 10000 && runner.md.is_hatched == 0) {
				//has_egg_to_hatch = runner.m_id;
				has_egg_to_hatch_i = ii;
				//console.log('egg to hatch: ' + has_egg_to_hatch_i)
			}
			ii++;
		}

		await getArtifacts();
	}

	async function getHabitats(type_id = 1) {

		is_loading = true;
		habitats = [];
		const res = await fetch(
			"https://api.forever.today/?method=get_habitats",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					type_id
				}),
			}
		);

		let habibi = [];
		const json = await res.json();
		let runners = json.data.habitats;
		for (const runner of runners) {
			//console.log(runner.name)
			//if (runner.id > 24) {
				habibi.push({
				id: runner.id,
				file_id: runner.file_id,
				url: runner.url,
				name: runner.name,
				s: runner.s,
				st_n: runner.st_n
				});
			/*} else {
				habibi.push({
				id: runner.id,
				url: "https://mebots.xyz/img/land42_" + runner.id + "_500.png",
				name: runner.name
				});
			}*/
		}

		if (type_id == 1) {
			if (habibi.length == 1)
				hab_visited_today = habibi.length + ' habitat ';
			else
				hab_visited_today = habibi.length + ' habitats ';
		}

		if (type_id == 2) {
			let mayor_count = json.data.mayor_count;
			if (mayor_count == 1) {
				mayor_h_num = ' 1 habitat '
			} else {
				mayor_h_num = mayor_count + ' habitats '
			}
		}

		if (json.data.can_claim == 1 && type_id == 1) {
			show_claim = true;
			if (habibi.length > 7) {
				habibi = habibi.slice(habibi.length-7, habibi.length)
			}
		}

		if (habibi.length == 0 && type_id == 1) {
			show_claim = true;
		}
		if (json.data.can_claim == 0 && type_id == 1 && habibi.length > 0) {
			show_claim = false;
		}
		if (habibi.length > 8) {
			habibi = habibi.slice(habibi.length-8, habibi.length)
		}

		habitats = habibi;
		is_loading = false;

		if (json.data.current.id > 0) {
			cur_hab_id = json.data.current.id
			//cur_hab_url = "https://mebots.xyz/img/land42_" + cur_hab_id + "_500.png"
			//console.log(cur_hab_url)
			//if (cur_hab_id > 24) {
				cur_hab_url = json.data.current.url;
			//}
		}

		if (json.data.total_dist != '0') {
			total_dist = json.data.total_dist;
//			if (total_dist > 99) {
//				parsecs_disp = 'psecs'
//			}
		}
		if (json.data.steps_taken != '') {
			steps_taken = json.data.steps_taken;
		}
		total_dist_in_square = json.data.total_dist_sq;
		total_dist_max = json.data.total_max;

		badge_n[0] = json.data.alerts_n[0];
		quest_level = json.data.quest_level;
		quest_streak = json.data.quest_streak;
		streak_completed = json.data.streak_completed;
		should_celebrate = json.data.celebrate;
		kickoffCelebrate();

		//	habitats = [];
		filterPlaces(type_id)

		getStructures();

		city_guilds = json.data.cur_guild;
	}

	async function kickoffCelebrate() {

		//if (selected_set.length >= game_size || found_rare > 0) {
		if (should_celebrate == 1 && quest_level > 0 && confetti_animation == false) {
		//if (true) {
			confetti_animation = true;
			confetti_loop();
			showMissionAccomplished(quest_level)
			setTimeout(function(){
				confetti_animation = false;
				should_celebrate = 0;
			}, 8000);
			doneCelebrating(quest_level);
		}
	}

	async function getHabitat(h_id) {

		h_sts = [];
		h_tags = [];
		h_settlers = [];
		h_count = 0;

		const res = await fetch(
			"https://api.forever.today/?method=get_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					habitat_id: h_id,
					mebot_id: m_id
				}),
			}
		);

		habitats[show_place_detail].s = 1;
		const json = await res.json();
		mayor_mebot_img_url = json.data.habitat.mebot_img_url;
		hab_mayor_id = json.data.habitat.mayor_id;
		is_mayor = json.data.habitat.is_mayor;
		is_fav_hab = json.data.habitat.is_fav;
		h_settlers_count = json.data.habitat.h_settlers_n;
		is_settled = json.data.habitat.is_settled;
		is_own = json.data.habitat.is_own;
		h_count = json.data.habitat.h_count;


		let runners = json.data.habitat.structures;
		let h_sts_tmp = [];
		for (const runner of runners) {
			h_sts_tmp.push({
				id: runner.id,
				name: runner.name,
				em: runner.em,
				class: runner.em
			});
		}
		h_sts = h_sts_tmp;
		h_tags = json.data.habitat.tags;

		h_tags = json.data.habitat.tags;
		habitat_tags = '';
		for (const t of h_tags) {
			habitat_tags = habitat_tags + '&nbsp;  ' + t + '<br>'
		}

		if (h_tags.length == 0 && h_count > 0) {
			habitat_tags = '<br><i>Visit this habitat IRL to see tags</i><br>'
		}

		let h_settlers_tmp = [];
		runners = json.data.habitat.h_settlers;
		for (const runner of runners) {
			h_settlers_tmp.push({
				id: runner.id,
				img_url: runner.img_url,
				s: runner.s
			});
		}
		h_settlers = h_settlers_tmp;

		if (json.data.habitat.sparks_n > 0) {
			showSparksFound(json.data.habitat.sparks_n, habitats[show_place_detail].name);
			sparklers_animation = true;
			sparklers_loop();
			setTimeout(function(){
				sparklers_animation = false;
			}, 8500);
		}


	}

	const filterPlaces = async (v) => {

        filter_pl_def = v;

		if (v == 1) {
			//Today
			show_places_today = true;
			if (habitats.length == 0) {
				habitats_empty = 'Bring your Mebot to a habitat today!'
			}
/*			for (let i = 17; i <= 22; i++) {
				habitats.push({
					url: "https://mebots.xyz/img/land42_" + i + "_500.png",
					name: "name"})
			}*/
		}

		if (v == 2) {
			//Mayor
			show_places_today = false;

			//habitat_msg = '<span style="display: flex; align-items:center; justify-content: center" >  <img src="' + my_mebot_img_url + '" width="21px" style="margin-left: 2px; margin-right: 2px;" /> is the mayor of ' + mayor_h_num + ' 👑 </span>';
			habitat_msg = '<span style="display: flex; align-items:center; justify-content: center" > You are the mayor of ' + mayor_h_num + ' 👑 </span>';

			if (habitats.length == 0) {
				habitats_empty = 'Find new locations and setup habitats.<br><br> Your Mebot will become Mayor 👑'
			}
		}

		if (v == 3) {
			//Local
			show_places_today = false;
			habitat_msg = 'Nearby habitats';

			if (habitats.length == 0) {
				habitats_empty = 'No nearby habitats found'
			}
		}

		if (v == 4) {
			//Top habitats
			show_places_today = false;
			habitat_msg = 'Favorite habitats';

			if (habitats.length == 0) {
				habitats_empty = 'No favorite habitats found'
			}
		}

		if (v == 5) {
			clear_badge_n(0);

			//Discovered habitats
			show_places_today = false;
			habitat_msg = 'All discovered habitats';

			if (habitats.length == 0) {
				habitats_empty = ' Take more 👟`s and let your Mebot discover new habitats!'
			}
		}

		if (v == 6) {
			//Top habitats
			show_places_today = false;
			habitat_msg = 'Recently viewed';
		}
	}

	function showMebot(i) {
		if (i >= 0) {
			//console.log(mebots[i].is_active)

			mebot_img_url = mebots[i].img;
			watt_level = mebots[i].watt_level;
			autopilot_level = mebots[i].autopilot_level;
			trips = mebots[i].trips;
			auto_walk = mebots[i].auto_walk;
			is_hatched = mebots[i].is_hatched;
			chain_id = mebots[i].chain_id;
			mtype = mebots[i].mtype;
			is_active = mebots[i].is_active;
			is_hatching = mebots[i].is_hatching;
			active_m_id = mebots[i].id;
			minted = mebots[i].minted;
			hatched = mebots[i].hatched;
			active_m_index = i;

/*			watts_score = json.data.watts.watt_score;
			steps = json.data.watts.steps;
			watt_level = json.data.md.watt_level;
			autopilot_level = json.data.md.autopilot_level;
			trips = json.data.md.trips;
			sparkles = json.data.md.sparkles;*/
			show_details = true;
			show_mebots = false;
			show_get_app = false;
		}
	}

	const displayMebotDetails = async (e) => {
		var i = Number(e.target.dataset.cardId)
		showMebot(i)
	};

	const showEggToHatch = async (e) => {
		showMebot(has_egg_to_hatch_i)
	}

	const displayArtifacts = async (e) => {
		show_artifact_detail = -1;
	}

	const displayArtifactDetails = async (e) => {
		var i = Number(e.target.dataset.cardId)

		if (i >= 0) {
			show_artifact_detail = i;
		}
	}

	const displayPlaces = async (e) => {
		show_place_detail = -1;
		habitat_details = -1;
	}

	function getPlaceDetail(i) {

		if (i >= 0) {
			is_mayor = 0;
			is_settled = 0;
			is_own = 0;
			mayor_mebot_img_url = null;
			hab_mayor_id = 0;
			show_place_detail = i;

			getHabitat(habitats[show_place_detail].id)
		}
	}

	const displayPlaceDetails = async (e) => {
		var i = Number(e.target.dataset.cardId)

		if (i >= 0) {
			getPlaceDetail(i)
		}
	}

	const showMebotTrip = async (e) => {
		var i = Number(e.target.dataset.cardId)

		if (!isNaN(i)) {
			console.log('do nothing ' + mebot_trips[i].id);
			trips_mebot_id = mebot_trips[i].id;
			getMebotTrips(trips_mebot_id);
		}

		return;
	}

	function showMebots() {
//		show_details = !show_details;

		show_artifacts = false;
		show_places = false;
		show_get_app = false;

		if (show_details && show_mebots == false) {
			doPost();
			show_details = false;
		}

		if (mebots.length > 1) {
			show_mebots = !show_mebots;
		} else {
			show_details = !show_details;
		}

	}

	function showArtifacts() {

		show_mebots = false;
		show_details = false;
		show_places = false;
		show_artifacts = true;
		show_artifact_detail = -1;
	}

	function showPlaces() {

		getHabitats(1);
		show_mebots = false;
		show_details = false;
		show_artifacts = false;
		show_places = true;
		show_place_detail = -1;
		habitat_details = -1;
		is_building = false;
		show_get_app = false;
	}

	function showMebotTrips(mebot_id = 0) {

		trips_mebot_id = mebot_id;
		//show_mebot_trips = !show_mebot_trips;
		show_mebot_trips = true;

		if (show_mebot_trips) {
			getMebotTrips(mebot_id);
		}

	}

	function displayDash() {
		//show_details = true;
		showMebots()
	}
	function displayWatts() {
		show_details = true;
	}

	function goTop() {
		document.body.scrollIntoView();
	}

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = true
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}
/*
	function displayMebotMessageClaim(msg, delay, action_button = false, action = null) {
		let is_show_close = false
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}
*/
	async function upgradeAutopilot(mebot_id) {

		const res = await fetch(
			"https://api.forever.today/?method=upgrade_autopilot",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
				}),
			}
		);

	}

	async function processAutopilotUpgrade() {

		//upgrade autopilot for the active meebot
		await upgradeAutopilot(active_m_id);

		//fetch autopilot values after upgrade
		await getMyMebots();

		//fetch up to date sparkle count
		await refreshSparkles();

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Congrats!</b><br><br>
		Mebot Autopilot Level successfully upgraded to: ` + autopilot_level + `</b><br><br>
		<br>
		</center>`, closeButton: true }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 5000);
	}

	async function buildStructure(mebot_id) {

		let habitat_id = habitats[show_place_detail].id;
		let s_id = structures[building_id].id;

		const res = await fetch(
			"https://api.forever.today/?method=build_habitat_structure",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					habitat_id,
					s_id
				}),
			}
		);

		await getHabitat(habitats[show_place_detail].id);
	}

	async function processSettleAction() {

		const res = await fetch(
			"https://api.forever.today/?method=settle_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: active_m_id,
					habitat_id: habitats[show_place_detail].id
				}),
			}
		);

		await refreshSparkles();
		await getHabitat(habitats[show_place_detail].id);

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Yay!</b><br><br>
		Your mebot settled at <b>` + habitats[show_place_detail].name + `</b> <br><br>

		<img src='` + my_mebot_img_url + `' width=100 height=100 alt=''><br>

		<br>
		</center>`, closeButton: true }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 7000);
	}

	async function processBuildAction() {

		await buildStructure(active_m_id);
		//fetch up to date sparkle count
		await refreshSparkles();

		is_building = false;

		let has_have = 'has';
		if (structures[building_id].id == 12) {
			has_have = 'have';
		}

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Yay!</b><br><br>
		<b>` + structures[building_id].name + `</b> ` + has_have + ` been built! <br><br>
		<br>
		</center>`, closeButton: true }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 7000);
	}

	async function claimHabitat(mebot_id) {

		claimed_habitat_error = '';

		const res = await fetch(
			"https://api.forever.today/?method=claim_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
				}),
			}
		);

		const json = await res.json();
		claimed_habitat_name = json.data.habitat.name;
		claimed_habitat_id = json.data.habitat.id;
		if (claimed_habitat_id == -1) {
			claimed_habitat_error = json.data.habitat.error;
		}

		getHabitats(1);
	}

	async function processClaimAction() {

		await claimHabitat(active_m_id);
		//fetch up to date sparkle count
		await refreshSparkles();

		if (claimed_habitat_id > 0) {

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Congrats!</b><br><br>
		Habitat location successfully setup. 📍<br><br> You are the Mayor of <b>` + claimed_habitat_name + `</b> habitat now.  👑 </b><br><br>
		<br>
		</center>`, closeButton: true, action_button: 'Nice!' }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 7000);

		} else {

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Uh oh!</b><br><br>
		There was a problem setting up habitat:<br><br>
		<i>` + claimed_habitat_error + `</i>
		<br><br>
		</center>`, closeButton: true, action_button: 'Ok' }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 20000);

		}
	}

	async function processAutoWalkChange() {
		console.log(active_m_id + ' - ' + auto_walk)

		const res = await fetch(
			"https://api.forever.today/?method=autowalk_mebot",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					active_m_id,
					auto_walk
				}),
			}
		);

		getMyMebots();
	}

	$: auto_walk, processAutoWalkChange();


	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

    function quest_phase(level) {

		switch (level) {
			case 1: return '🌟🌑🌑'
			case 2: return '🌟🌟🌑'
			case 3: return '🌟🌟🌟'
		}
		return '🌑🌑🌑'
	}

	function showWattLevelInfo() {

		displayMebotMessage(`
		<center>

			` + watt_level_info + `

		</center>`, 25000, '⚡');
	}

	function showGetApp() {

		displayMebotMessage(`
		<center>
			<br><br>
		<b>Find a Mebot egg 🥚 🎉! </b><br><br>

		Find gems 💎, artifacts and eggs 🥚 in habitats!<br>

		<br><br>
		</center>`, 10000, 'Show me how', onShowMeGetAppAction);

	}
	function showAccomplishMission() {

		displayMebotMessage(`
		<center>
			<br><br>

		Complete <b>Daily Quest</b> 🌟<br><br><br> Earn rewards 🎽 🦾 💫 for your Mebot! </b><br>

		<br><br>
		</center>`, 15000, 'Show me how 👉', onShowMeHowAction);
	}

	function showMood() {

		displayMebotMessage(`<center>
			<br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> ` + mebot_mood + ` </div>
			</div>
			<br>
			` + mebot_mood_desc + `
			<br><br>
		</center>`, 10000, 'Okay');

	}

	function showHatchingGuide() {

		displayMebotMessage(`
		<center>
			<br><br>
		<b>Mebot Hatching Guide 👇</b><br><br>

		<img src="https://app.mebots.xyz/img/mebots-hatch-750.png" width=160px>

		<br><br>
		</center>`, 10000, 'Ok');
	}

	function showMissionAccomplished(level) {
		let title = 'Great Success!'

		if (level > 0 && quest_streak == 0) {
			quest_streak = 1;
		}

		let streak_tiles = '';
		for (let i = 0; i < 10; i++) {
			if (i < quest_streak) {
				streak_tiles += '🟦'
			} else {
				streak_tiles += '⬜️'
			}
		}
		streak_tiles += ' 🎽<br>'

		let current_streak = '';
		//if (quest_streak > 0) {
			current_streak = `Current 10-day streak: <font color="lightblue"><b> ` + quest_streak + ` / 10</b></font><br>
					` + streak_tiles + `
			<br>`
		//}

		let daily_streak_msg = `
			Complete a <b>Daily Quest</b> for 10 days straight and participate in
		<span style="display: flex; align-items:center;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			100,000 prize pool!
		</span>
		<br>`;

		if (streak_completed > 0 && quest_streak >= 10) {
			daily_streak_msg = `
			Wow, kudos! 👍 <br> <b>10-day quest streak</b> completed!<br><br> Your active Mebot was awarded<br> a Marathoner 🎽 badge and you will participate in
		<span style="display: flex; align-items:center;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			100,000 prize pool
		</span>
		at the end of this month!
		<br><br>`;
		} else if (streak_completed == 0 && ironman_badges == 0) {
			daily_streak_msg = daily_streak_msg + `
			Your Mebot will also earn a Marathon 🎽 badge when you complete 10-day streak. 👍
		<br><br>`;
		}

		if (streak_completed > 0 || ironman_badges > 0) {

			let ironman_streak_tiles = '';
			for (let i = 0; i < 3; i++) {
				if (i < streak_completed) {
					ironman_streak_tiles += '🎽'
				} else {
					ironman_streak_tiles += '⬜️'
				}
			}
			//recently completed 10-day streaks (w/in 45 days)
			daily_streak_msg = daily_streak_msg + `<br>10-day streaks: <font color="lightblue"><b>` + streak_completed + ` / 3</b></font><br>
			` + ironman_streak_tiles + ` 🦾<br><br>`;

			if (streak_completed < 3) {
				daily_streak_msg = daily_streak_msg + `Complete 3 streaks in 45 days or less to earn Ironman 🦾 badge!`;
			} else {
				daily_streak_msg = daily_streak_msg + `<br>Congrats! Your active Mebot was awarded an  Ironman 🦾 badge for completing 3 x 10-day streaks! 🎉`;

				if (ironman_badges == 0) {
					ironman_badges = 1;
				}
			}
			daily_streak_msg = daily_streak_msg + `<br><br>`;

			if (ironman_badges > 0) {

				if (ironman_badges < 7) {
					daily_streak_msg = daily_streak_msg + `Complete 7 x Ironman and earn the most exclusive and rare <b>Ultraman</b> 🏅 badge 🤯<br>`;
				} else {
					daily_streak_msg = daily_streak_msg + `Congrats 🍾 you've scored the most exclusive and rare <b>Ultraman</b> 🏅 badge 🤯<br>`;
				}

				let ultraman_streak_tiles = '';
				for (let i = 0; i < 7; i++) {
					if (i < ironman_badges) {
						ultraman_streak_tiles += '🦾'
					} else {
						ultraman_streak_tiles += '⬜️'
					}
				}
				//[` + ironman_badges + ` / 10 
				daily_streak_msg = daily_streak_msg + `<br>  Total Ironmen: <font color="darkgrey"><b> ` + ironman_badges + ` / 7</b></font> <br>
				 ` + ultraman_streak_tiles + `🏅 <br>`;

				daily_streak_msg = daily_streak_msg + `<br>`;
			}
		}

		switch (level) {
			case 0:
			displayMebotMessage(`
		<center>
			<br><br>
		<b>Daily Quests 🌟 </b><br><br>

		🌑🌑🌑<br>
		<i>No quests completed today</i><br><br>

		<font color="gold">Level 1</font>: Take <span style="color: lightblue;">2K steps</span> 👟 and<br> travel <span style="color: lightblue;">1 Parsec</span> 🏃 &nbsp;🌌<br><br>
		<font color="gold">Level 2</font>: Take <span style="color: lightblue;">4K steps</span> 👟 and<br> travel <span style="color: lightblue;">4 Parsecs</span> 🏃 &nbsp;🌌<br><br>
		<font color="gold">Level 3</font>: Take <span style="color: lightblue;">9K steps</span> 👟 and<br> travel <span style="color: lightblue;">9 Parsecs</span> 🏃 &nbsp;🌌<br><br>

		Participate in daily prize <img src='/img/sparkle-zm1.png' width=24px; alt='sparkle'> pool by completing each level of the quest!
		<br><br><br>

		` + current_streak + `

		` + daily_streak_msg + `

		<div><br>
		How to complete <font color="gold">Level 1</font>👇 <br><br>
		<img style="border-radius: 10px;" src="https://app.mebots.xyz/img/mebot_daily-quest-guide-6-j.jpg" width="300px" height="402px">
		</div>

		<br>
		</center>`, 60000, 'Bring It On!');
			return;

			case 1:
				title = 'Nice going!';
				break;
			case 2:
				title = 'Great work!';
				break;
			case 3:
				title = 'Amazing feat!';
				break;
		}

		displayMebotMessage(`
		<center>
			<br><br>
		<b>Congrats! 🎇 </b><br><br><br>

		Daily Quest Complete:<br><br> <font color="gold"><b>Level ` + level + `</b></font><br><br>
		You've earned a share of
		<span style="display: flex; align-items:center;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			Daily prize pool.
		</span>
		<br><br>
		Daily Streak: <font color="lightblue"><b> ` + quest_streak + ` / 10</b></font><br>
		` + streak_tiles + `
		<br>

		` + daily_streak_msg + `

		<br>
		</center>`, 20000, title, onGreatSuccessAction);

	}

	function showSparksFound(n_sparks, base) {

		displayMebotMessage(`
		<center>
			<br><br>
		<b>Yay! 🌟 </b><br><br>

		You found ` + n_sparks + ` sparks<br> ✨✨✨<br> at <b>` + base + `</b>
		<br><br>
		</center>`, 7000, 'Nice!');
	}

	function displayAutopilotNotEnough() {
		displayMebotMessage(`
		<center>
			<br><br>
		<b>Mebot Autopilot Level: ` + autopilot_level + `</b><br><br>

		Autopilot upgrade cost:<br><br>
		<span style="display: flex; align-items:center;" >
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			100,000
		</span>
		<br><br>

		Your current balance is too low.

		<br><br><br>
		</center>`, 7000);

	}

	function displayAutopilotUpgrade() {
		displayMebotMessage(`
		<center>
			<br><br>
		<b>Mebot Autopilot Level: ` + autopilot_level + `</b><br><br>

		Autopilot upgrade cost:<br><br>
		<span style="display: flex; align-items:center;" >
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			100,000
		</span>
		<br><br>
		</center>`, 7000, 'Upgrade', onAction);

	}

	function displayClaimLocationNotEnough() {
		displayMebotMessage(`
		<center>
			<br><br>
			<b>📍 New location found!<br><br>
			Claim this habitat location 📍</b><br><br>

			Become Mayor of this habitat  👑 <br><br>

			<span style="display: flex; align-items:center;" >
			Habitat setup cost:
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			1,000
			</span>
			<br><br>

			<span style="display: flex; align-items:center;" >
			Your current balance ( <img src='/img/sparkle-zm1.png' width=24px; alt=''>` + sparkles + ` ) is too low.
			</span>

		<br><br><br>
		</center>`, 10000);

	}

	function displayClaimLocation() {
		displayMebotMessage(`
		<center>
			<br><br>
		<b>📍 New location found!<br><br>
			Claim this habitat location 📍</b><br><br>

			Become Mayor of this habitat  👑 <br><br>

			<span style="display: flex; align-items:center;" >
			Habitat setup cost:

			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			1,000
		</span>
		<br><br>
		</center>`, 10000, ' 📍 Setup habitat 🗺️ ', onClaimAction);

	}

	function displaySettlerVisitor(img_url, is_settler, is_mayor) {

		let msg = 'Visitor';
		if (is_settler) {
			msg = 'Settler';
		}
		if (is_mayor) {
			msg = 'Habitat Mayor';
		}

		displayMebotMessage(`
		<center>
			<br><br><b>` + habitats[show_place_detail].name + `</b><br><br>

			<img src='` + img_url + `' width=100 height=100 alt=''><br>

			` + msg + `

			<br><br>
		</center>`, 5000);
	}
	function displayMayor() {

		let owner_msg = '';
		if (is_mayor) {
			owner_msg = '<br> You are the owner and mayor of this habitat. <br>';
		}

		displayMebotMessage(`
		<center>
			<br><br>
			👑&nbsp; Mayor of ` + habitats[show_place_detail].name + `</b><br><br>

			<img src='` + mayor_mebot_img_url + `' width=100 height=100 alt=''><br>

			` + owner_msg + `

			<br><br>
		</center>`, 5000);
	}

	function displayMySettled() {

		displayMebotMessage(`
		<center>
			<br><br>
			Your mebot is settled in this habitat</b><br><br>

			<img src='` + my_mebot_img_url + `' width=100 height=100 alt=''><br>

			<br>
		</center>`, 5000);
	}


	function displayTags() {

		if (h_tags.length == 0 && h_count > 0) {
			displayMebotMessage(`
		<center>
			<br><br>
			🏷️ Tags at this habitat: (` + h_count + `)
			<br><br>` + habitat_tags + `
			<br><br>
		</center>`, 10000, 'View Habitat', onTagAddAction);

		} else {

		displayMebotMessage(`
		<center>
			<br><br>
			🏷️ Tags at this habitat:
			<br><br>` + habitat_tags + `
			<br><br>
		</center>`, 10000, 'View Habitat', onTagAddAction);

		}
	}

	const onTagAddAction = () => {
		console.log('add action')

		//hab_tag = '';
		//show_add_tag = true;
		push('/habitat/2/' + habitats[show_place_detail].file_id)
    };

	function displayTreasure() {

		displayMebotMessage(`
		<center>
			<br><br>
			Treasure chest at this habitat contains:<br><br><br>

			<br>
		</center>`, 10000);
	}

	function viewHabitatDetails(hab_id) {

		habitat_details = hab_id
	}

	async function canBuildStructure() {

		const res = await fetch(
			"https://api.forever.today/?method=can_build",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token
				}),
			}
		);
		const json = await res.json();
		can_build = json.data.can_build;

		habitat_details = -1;

		let eng_id = Math.floor(Math.random() * 7 + 1);
		let eng_id_files = [];
		eng_id_files[1] = '5f1ad55d4d130647d012d01ff7c02a223f828f0c';
		eng_id_files[2] = '8a8831190800ac7c9f2948b7b46d8b9c43817966';
		eng_id_files[3] = '20cdfa41f3a99223af9c895faafcc9b068ab8bb1';
		eng_id_files[4] = '3b138564d1be17a108d6e69ea8d4a4f779944214';
		eng_id_files[5] = '445f7ede2742beb3cdc75bd661d20a70052db76b';
		eng_id_files[6] = 'f55676743763aeff21cf1f60b072fceb61107583';
		eng_id_files[7] = '2e2dc1383ba0993b6d30454a7b8e986055b0e621';

		if (can_build == 1) {

			//refresh to see what structure already built in this habitat
			getStructures(habitats[show_place_detail].id)
			is_building = true;
		} else {
			displayMebotMessage(`
		<center>
			<br><br><br>
			You need <b>Engineer</b> class Mebot to build structures in habitats.
			<br><br>
			<img src='https://mebots.s3.amazonaws.com/` + eng_id_files[eng_id] + `plain_500' width=100 height=100 alt=''><br>
			Engineer

		<br><br><br>
		</center>`, 10000, 'Okay');
		}

	}

	function displaySettleHere(hab_name, cost) {

		if (sparkles < cost) {

			displayMebotMessage(`
		<center>
			<br><br>
			Settle your mebot at<br> <b>` + hab_name + ` </b> habitat?<br><br>

			Cost:<br><br>
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			` + numberWithCommas(cost) + `
			<br><br>

			Your current balance is too low to settle your mebot here.
			<br><br>
		</center>`, 10000);

		} else {

		displayMebotMessage(`
		<center>
			<br><br>
			Settle your mebot at<br> <b>` + hab_name + ` </b> habitat?<br><br>

			Cost:<br><br>
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			` + numberWithCommas(cost) + `

			<br><br><br>
		</center>`, 10000, 'Settle', onSettleAction);

		}
	}

	function displayBuildStructure(b_id) {

		building_id = b_id;

		if (structures[building_id].is_built == 1) {
			console.log('trying to build existing structure')
			return;
		}

		if (sparkles < structures[building_id].cost) {

			displayMebotMessage(`
		<center>
			<br><br>
			<b> <font size="7">  ` + structures[building_id].em + `</font></b> <br><br>
			Build <b>` + structures[building_id].name + `</b><br> at <b>` + habitats[show_place_detail].name + `</b><br><br> Cost:<br><br>
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			` + numberWithCommas(structures[building_id].cost) + `
			<br><br>

			Your current balance is too low to build.
			<br><br><br>
		</center>`, 10000);

		} else {

		displayMebotMessage(`
		<center>
			<br><br>
			<b> <font size="7">  ` + structures[building_id].em + `</font></b> <br><br>
			Build <b>` + structures[building_id].name + `</b><br> at <b>` + habitats[show_place_detail].name + `</b><br><br> Cost:<br><br>
			<img src='/img/sparkle-zm1.png' width=24px; alt=''>
			` + numberWithCommas(structures[building_id].cost) + `
			<br><br>
			<br>
		</center>`, 10000, 'Build', onBuildAction);

		}
	}

	function displayParsecDetails() {

		let steps_took = '';
		if (steps_taken != '') {
			steps_took = `and took <span style="color: gold;">` + steps_taken + ` steps</span>`;
		}

		displayMebotMessage(`
		<center>
			<br><br>
			<img src='` + my_mebot_img_url + `' width=100 height=100 alt=''><br><br>

			` + mebot_power + `
			` + battleness + `

			<br><br>
			<b> <span style="color: lightblue;">` + total_dist + ` Parsecs</span></b>
			<br>
			<span style="color: lightblue;">0&nbsp;&nbsp;` + total_dist_in_square + `&nbsp; ` + total_dist_max + `</span><br>
			<br>

			Your mebot traveled <span style="color: lightblue;">` + total_dist + ` parsecs</span> ` + steps_took + ` in the last 12 hours.
			<br><br>
			<span style="color: lightblue;">Parsecs</span> are a unit of distance in Land42.<br><br>
		     <i>Visit more habitats to increase parsecs traveled.</i>
			<br><br><br>
		</center>`, 40000, 'Okay');
	}

	function goHabitatsToday() {

		showPlaces();
	}

	function displayHabitatsToday() {
		displayMebotMessage(`
		<center>
			<br><br>
			<img src='` + my_mebot_img_url + `' width=100 height=100 alt=''><br><br>
			<b> <span style="color: lightblue;">` + hab_visited_today + `</span> </b>
			<br><br>
			Your mebot visited <b><span style="color: lightblue;">` + hab_visited_today + `</span></b> in the last 12 hours.<br><br> Setup or find new habitats today!
			<br><br><br>
		</center>`, 7000);
	}

	function displayAutoWalk() {
		displayMebotMessage(`
		<center>
			<br><br><br>
		<b>Auto Walk setting: ` + (auto_walk == 1 ? 'ON' : 'OFF') + `</b><br><br>

			Turn it on if you would like this Mebot to consume your steps and collect <img src='/img/sparkle-zm1.png' width=24px; alt=''> in the background.

		<br><br><br>
		</center>`, 7000);
	}

	function displayMoonPhaseDetails() {
		let msg = mebot_moon_phase_days == 1 ? '1 day' : mebot_moon_phase_days + ' days';
		if (mebot_moon_phase_days >= 13) {
			msg = 'everyday'
		}

		let mebot_str = 'Mebot'
		if (chain_id < 0) {
			mebot_str = 'Mebot ghost'
		}

		displayMebotMessage(`
		<center>
			<br><br> ` + moon_phase(mebot_moon_phase) + `<br><br>

		Your ` + mebot_str + ` has been active <b>` + msg + `</b> in the last two weeks!
	
		<br><br><br>
		</center>`, 7000);
	}

	function displayStepDetails() {

		let mebot_str = 'Mebot'
		if (chain_id < 0) {
			mebot_str = 'Mebot'
		}

		let msg = '';
		if (mebot_14day_steps_n < 20) {
			msg = '<br><br>Your ' + mebot_str + ' could use some more movement!'
		}

		displayMebotMessage(`
		<center>
			<br><br>
			<div class="text-electric" style="font-size: 65px;" >
			👟
			</div>
			<br>

		Your ` + mebot_str + ` took  <span style="color: #1bffe8ee;"><b>` + today_n + `</b></span> steps today.<br><br>

		Your ` + mebot_str + ` took total <span style="color: #1bffe8ee;"><b>` + mebot_total_n + `</b></span> steps.<br><br>

		Your ` + mebot_str + ` took <span style="color: #1bffe8ee;"><b>` + mebot_14day_steps + `</b></span> steps per day on average in the last two weeks!
		` + msg + `
		<br><br><br>
		</center>`, 7000);
	}

	function displayMebotClass() {

		if (chain_id > 0) {
		displayMebotMessage(`
		<center>
			<br><br> ` + display_mebot_class(mebot_class_id) + `<br><br>

			<b>` + mebot_class_name + ` Mebot</b>

		<br><br><br>
		</center>`, 7000);
		} else {
		displayMebotMessage(`
		<center>
			<br><br> ` + display_mebot_class(mebot_class_id) + `<br><br>

			<b>Mebot Ghost</b>

		<br><br><br>
		</center>`, 7000);

		}
	}

	function autopilotUpdate() {

		if (sparkles < 100000) {
			displayAutopilotNotEnough();
		} else {
			displayAutopilotUpgrade();
			//processAutopilotUpgrade();
		}
	}

	function displaySetupHabitat() {

		if (sparkles < 1000) {
			displayClaimLocationNotEnough();
		} else {
			displayClaimLocation();
		}
	}

	async function activateMebot(mebot_id) {
		const res = await fetch(
			"https://api.forever.today/?method=activate_mebot",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id
				}),
			}
		);

		m_id = mebot_id;
		const json = await res.json();
	}

	async function hatchMebot(mebot_id) {
		const res = await fetch(
			"https://api.forever.today/?method=hatch_mebot",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id
				}),
			}
		);

		const json = await res.json();
	}

	async function getMebotTrips(mebot_id) {

		show_details = false;
		show_get_app = false;

		const res = await fetch(
			"https://api.forever.today/?method=get_mebot_trips",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.trips;

		mebot_attr = json.data.attr;
		mebot_trips_tmp = [];
		let info_str = '';
		let land = null;

		for (const runner of runners) {

			land = null;
			if (runner.info != null) {
				info_str = runner.info

				if (runner.land_img != null) {
					land = runner.land_img
				}
			} else {
				info_str = runner.eff + '%'
			}
			mebot_trips_tmp.push({
				id: runner.m_id,
				img: runner.mebot_img_url,
				land_img: land,
				land_file_id: runner.land_file_id,
				sparkles: runner.sparkles,
				eff: runner.eff,
				info: info_str,
				time_ago: runner.time_ago
			});
		}
		mebot_trips = mebot_trips_tmp.slice(0, 14);

	}

	async function processActivationHatch(mebot_id) {

		console.log(active_m_id)
		if (is_hatched == 1) {

			is_active = 1;
			await activateMebot(active_m_id);
			doPost();
		} else {

			await hatchMebot(active_m_id);
			await getMyMebots();
			//doPost();
			//getMyMebots();
			minted = mebots[active_m_index].minted;
			hatched = mebots[active_m_index].hatched;
			is_hatching = 1;
		}
	}

	function copyToClipboard(textToCopy) {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	}

	function copySuccess() {

		let qr_msg = '';
		if (social_qr != '') {
			qr_msg = `<br><br><br>Invite friends via QR <br>Let them scan this code 👇 <br><br>
			<div style="background: white; width: 190px; height: 180px; border-radius: 10px;"><img src="` + social_qr + `" width=180px height=180px></div> <br>
			<div style=" width: 90px; height: 90px; border-radius: 10px;"><img src="` + mebot_img_url + `" width=90px height=90px></div>
			`;
		}

		displayMebotMessage(`
		<center>
		<br><br><br>
		<b><font color="lightblue">` + social_link + `</font></b><br><br><br>

		Mebot link copied to your clipboard.<br><br>
		Share it with your friends and score bounty ✨ ⬆️	

		` + num_invites + `

		` + qr_msg + `

		<br>
		`, 20000, 'Done!');
	}

	function copyError() {

		let qr_msg = '';
		if (social_qr != '') {
			qr_msg = `<br><br><br>Invite friends via QR <br>Let them scan this code 👇 <br><br>
			<div style="background: white; width: 100px; height: 100px; border-radius: 10px;"><img src="` + social_qr + `" width=100px height=100px></div>
			`;
		}

		displayMebotMessage(`
		<center>
		<br><br>
		<span style="font-size: 14px;" >
		Share your Mebot invite link:<br><br>
		<input size=26 value="` + social_link + `"></input><br><br>
		Copy & share it with your friends to score bounty ✨ ⬆️

		` + num_invites + `

		` + qr_msg + `

		<br><br>
		</span>
		`, 100000, 'Done');
	}

	function copySocial() {
		var copyText = document.getElementById("social_link");
		//alert("Copied the text: " + copyText.value);

		copyToClipboard(copyText.value)
			.then(() => copySuccess())
			.catch(() => copyError());

		copied = true;
			setTimeout(
				function() {
					copied = false;
				},
			300
		);
	}

	function alpha_mebot() {

		return false;

		let m_id = getCookie('m_id');

		if (m_id == 59 || m_id == 76 || m_id == 87 || m_id == 250 || m_id == 110) {
			return true;
		}
		return false;

		return true;
		if (m_id == 59 || m_id == 76 || m_id == 87 || m_id == 250 || m_id == 110 || m_id == 1 || m_id == 308 || m_id == 368 || m_id == 3760) {
		//if (m_id == 76 || m_id == 87 || m_id == 250 || m_id == 1 || m_id == 110) {
		//if (m_id == 76 || m_id == 87 || m_id == 2 || m_id == 376) {
			return true;
		}
		return false;
	}

	doPost();
	goTop();

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.0012 };
	const animateIn = (node) => {
		const { duration, tickToValue } = springIn(-6, 0, SPRING_IN);
		return {
			duration: ( (is_hatched == 1 || m_id > 10000) ? 50000 : 0),
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};
	const animateIn1 = (node) => {
		const { duration, tickToValue } = springIn(-4, 0, { stiffness: charged, damping: 0.001 });
		return {
			duration: (is_hatched == 1 ? 50000 : 0),
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

    let upgrade_autopilot = 0;

    const onAction = () => {
		upgrade_autopilot = 1;
		console.log('upgrade')
		autopilot_level++;
		processAutopilotUpgrade()
    };

	const onShowMeHowAction = () => {
		showMissionAccomplished(quest_level);
    };

	const onShowMeGetAppAction = () => {
		email_signup = '';
		show_mebots = false;
		show_details = false;
		show_artifacts = false;

		show_get_app = true;
		show_get_app_result = false;
    };

    const onGreatSuccessAction = () => {
		setTimeout(function(){
			confetti_animation = false;
			should_celebrate = 0;
			doneCelebrating(quest_level);
		}, 1200);
    };

    const onClaimAction = () => {
		console.log('claim action')
		show_claim = false;
		processClaimAction()
    };

	const onBuildAction = () => {
		console.log('build action')
		processBuildAction()
    };

	const onSettleAction = () => {
		console.log('settle action')
		processSettleAction()
    };

    function moon_phase(phase) {

		switch (phase) {
			case 0: return '🌑'
			case 1: return '🌘'
			case 2: return '🌗'
			case 3: return '🌖'
			case 4: return '🌕'
		}
		return '🌘'

	}

	async function sendEmail() {

		let field = document.getElementById('email_input')
		field.focus();
		field.inputMode = "none";
/*
		setTimeout(function() {
			field.blur();
	     	field.setAttribute('style', 'display:none;');
			console.log('hidden')
		}, 50);

		console.log('add action: ' + hab_tag)
*/
		if (email_signup != '') {

		const res = await fetch(
			"https://api.forever.today/?method=signup",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					signup_email: email_signup
				}),
			}
		);

		show_get_app_result = true;
		//show_get_app = false;
		}
	}

	function display_mebot_class(class_id){

		if (chain_id < 0) {
			return '👻'
		}

		switch (class_id) {
			case 1: return '🐾'
			case 2: return '🏋️'
			case 3: return '🏗️'
			case 4: return '🐗'
			case 5: return '🧪'
			case 6: return '🦅'
		}
		return ''

	}

	function show_badge_n(n) {

		if (isNaN(badge_n[n]) || badge_n[n] == 0  || badge_n[n] == '') {
			return '';
		} else {
			return badge_n[n];
		}
	}

	function clear_badge_n(n) {
		badge_n[n] = '';
	}

	function displayIntroMessage() {

		let intro_played = getCookie("intro_quests");
		is_anon = getCookie("is_anon");
		if (is_anon == 1) {
			show_get_app = true;
		}
		map_badge_n = getCookie("map_badge_n");
		news_badge_n = getCookie("news_badge_n");
		console.log(is_anon + ' : ' + map_badge_n)
		if (intro_played != 'yes') {

			if (is_anon == 1) {
				showGetApp();
			} else {
				showAccomplishMission();
			}
		}

		if (quest_level == 0) {
			setCookie("intro_quests", 'yes', 14);
		} else {
			setCookie("intro_quests", 'yes', 60);
		}
	}

	function showCityGuilds() {
		return true;

		displayMebotMessage(`
		<center>
			<br><br>
			` + city_guilds + `
			<br><br>
		</center>`, 25000, '  ♾️   ');
	}


	async function sellArtifactAction() {

		let res = await fetch(
			"https://api.forever.today/?method=sell_artifact",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					a_id: artifacts[show_artifact_detail].id
				}),
			}
		);

		let json = await res.json();

		await doPost();
		show_artifact_detail = -1;
		return true;
    }

	function sellArtifact(info) {

		displayMebotMessage(`
		<center>
			<br><br>
			` + info + `
			<br><br>
		</center>`, 20000, 'Sell', sellArtifactAction);
	}

	displayIntroMessage();

	let x = 800 // the value returned by getX() function
	let article_n = 0; // number of items that load on the page initially

	const loadOnArtifactScroll = (elem) => {
		//console.log('scrollTop: ' + elem.scrollTop + ' scrollHeight: ' + elem.scrollHeight);
		if (elem.scrollTop >= (elem.scrollHeight - x) ) {

			if (artifact_fetching == false) {
				article_n += artifact_page_size;
				getArtifacts(article_n);
				console.log('article_n: ' + article_n);
			}
		}
	}

	function goChat() {
		replace("/chat/2/1");
	}

	function showJourney() {

		displayMebotMessage(`
	<center>
	<br><br>

	` + journey['info_full']  + `

	<br><br>
	</center>`, 20000, 'Guide me 💬', goChat);

	}

</script>

<!--<button on:click={() => pop()}>Back</button><br>
<br><br><br>-->

<!--<span class="text-glow lbls">Your name is: {mebot_img_url} {result}</span>-->

<!--
<button class="btn" style="position: absolute; top: 270px; left: 10px; z-index: 100" on:click={increment}>
	&times;
</button>
-->

<!--
<button class="btn" style="position: absolute; top: 270px; left: 310px; z-index: 100" on:click={increment}>
	&#10003;
</button>
-->

<!--<button class="btn-saved" style="position: absolute; top: 100px; left: 307px; z-index: 100" on:click={add_favorite}>
	&#9733;
</button>-->

{#if confetti_animation }
	<div transition:fade|local={{duration: 300}}>
	{#each confetti as c}
		<div class="congratulations" style="z-index: 100; left: {c.x}%; top: {c.y}%; transform: scale({c.r})">{c.character}</div>
	{/each}
	</div>
{/if}
{#if sparklers_animation }
	<div transition:fade|local={{duration: 300}}>
	{#each sparklers as c}
		<div class="sparks_found" style="z-index: 100; left: {c.x}%; top: {c.y}%; transform: scale({c.r})">{c.character}</div>
	{/each}
	</div>
{/if}

<Header header_mebot_id={m_id} header_dash_token={dash_token} mebot_url={my_mebot_img_url} map_badge_n={map_badge_n} news_badge_n={news_badge_n} />

{#if mebot_img_url}
	<center>
		<div class="snake_row" style="user-select: none;">
			<center>
			<table width=330px valign=middle height=24px border=0>
			<tr valign=top>
			<td valign=middle width=150px align=left>
				<span style="display: flex; align-items:center; white-space: nowrap;" >
				{#if (true || show_details || show_mebots) && sparkles >= 0 }
					<span class="text-electric" style="color:silver; margin-top: 4px;" >
						<span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=24px height=24px alt='sparkle'></span>
					</span>
					<span class="text-electric-white" style="display: flex; align-items:center;" >
						<span class="vitals1 text-glow" class:balance-pulsing={ is_balance_pulse } style="" on:click={() => showMebotTrips(0)}> { numberWithCommas(sparkles) } </span>
						{#if trips_mebot_id == 0 && is_anon != 1}
						<span class="vitals1 text-glow" style="font-size: 10px;" on:click={() => showMissionAccomplished(quest_level) } >&nbsp; &nbsp; { quest_phase(quest_level) } </span>
						{/if}
					</span>
					&nbsp; &nbsp;
					{#if trips_mebot_id > 0 && !isNaN(mebot_attr.exp)}
					<span class="text-electric" style="color:silver; margin-top: 4px;" >
						{#if mebot_attr.img_url != '' }
						<span class="text-electric-yellow" style="font-size:0;"><img src='{mebot_attr.img_url}' width=24px height=24px alt='sparkle'></span>
						{:else}
						<span class="text-electric-yellow" style="font-size:0;"><img src='/img/pixel.png' width=24px height=24px alt='sparkle'></span>
						{/if}
					</span>
					&nbsp;
					<span class="text-electric-white" >
						<div class="vitals1 text-glow" style=""> 🎮&nbsp; </div>
					</span>
					&nbsp;
					<span class="text-electric-white" on:click={() => showMebotTrips(0)}>
						<div class="vitals1 text-glow" style=""> { numberWithCommas(mebot_attr.exp) } </div>
					</span>
					{/if}
				{:else}
				<span class="text-electric" style="color:silver; margin-top: 4px;" >
					<span class="text-electric-yellow" style="font-size:0;"> &nbsp; </span>
				</span>
				<span class="text-electric-white" >
					<div class="vitals1 text-glow" style=""> &nbsp; </div>
				</span>
				{/if}
				</span>
			</td>
			<td width=170px align=right height=40px>
				<span style="white-space: nowrap;" >
				{#if !show_mebot_trips }

				{#if is_anon == 1 }
				<button class="menu_btn_mebots claim_active" on:click={ onShowMeGetAppAction }>
					<span style="letter-spacing: -em; padding-left: 4px; padding-right: 4px;"> Get App 📱</span>
				</button>
				&nbsp;
				{/if}

				{#if cur_hab_url != '' && show_claim == false }
				<button class="menu_btn_mebots" style="position: relative; background-size: 35px; background-image: url({cur_hab_url}); background-repeat: no-repeat; background-position: center;" class:menu_active={ (show_places) } on:click={showPlaces}>
					<span style="letter-spacing: -em; padding-left: 4px; padding-right: 4px;">⊹</span>
					{#if false && badge_n[0] > 0 }
					<span class="habitat__badge">{ show_badge_n(0) }</span>
					{/if}
				</button>
				{:else}
				<button class="menu_btn_mebots" style="position: relative;" class:claim_active={ show_claim } class:menu_active={ (show_places) } on:click={showPlaces}>
					<span style="letter-spacing: -em; padding-left: 4px; padding-right: 4px;">⊹</span>
					{#if false && badge_n[0] > 0 }
					<span class="habitat__badge">{ show_badge_n(0) }</span>
					{/if}
				</button>
				{/if}
				{#if true }
				&nbsp;
				<button class="menu_btn_mebots" style="position: relative;" class:menu_active={ (show_artifacts) } on:click={showArtifacts}>
					<span style="letter-spacing: -em; padding-left: 4px; padding-right: 4px;">@</span>
					{#if artifacts_n > 0 }
					<span class="mebots__badge">{ artifacts_n }</span>
					{/if}
				</button>
				{/if}
				{#if true }
				&nbsp;
				<!--
				<a href="/#/map/2/1">
				<button class="menu_btn_mebots text-electric-location2">
					<span style="padding-left: 2px; padding-right: 2px;">📍</span>
				</button>
				</a>
				&nbsp;-->
				{/if}

				<button class="menu_btn_mebots submenu_active1" style="position: relative;" class:menu_active={ (show_mebots || show_details) } on:click={showMebots}>
					<span style="letter-spacing: -em">&nbsp;⋮⋮⋮&nbsp;</span>
					{#if mebots.length > 1 }
					<span class="mebots__badge">{ mebots.length }</span>
					{/if}
				</button>

				{:else}
				&nbsp;
				{/if}
				</span>
			</td>
			</tr>
			</table>
			</center>
			<br>

			{#if show_get_app }
			<center>
			<table width=290px border=0>
				<tr>
					<td align=center>

						{#if show_get_app_result }
						<span class="text-electric">
						<br><br><br><br>
						<b>1.</b> Get app: <br><br>
						<center>
						<table width=290px>
						<tr style="padding=15px"><td style="text-align:center"><a href="https://apps.apple.com/us/app/forever-steps/id1616422453" target="_new"><img src="https://app.mebots.xyz/img/appstore.png" style="margin-top: 5px" height="36px"></a></td><td style="text-align:center" valign="top"><a href="https://play.google.com/store/apps/details?id=today.forever.steps" target="_new"><img src="https://app.mebots.xyz/img/googleplay.png" height="38px" style="margin-top: 5px"></a></td></tr>
						</table>
						</center>
						<br><br>
						<span class="text-electric"><b>2.</b> Check your email for the app 📱 login code.</span>
						<br><br>
						</span>
						{:else}
						<span class="text-electric">
						<br>
						Get App 📱</span><br>
						<br>
						<div><img style="border-radius: 10px;" src="/img/egg-winner1.png" width="180px" height="129px"></div>
						<br>
						<span class="text-electric">
							Enter your email 👇<br><br>
							<input id="email_input" bind:value={email_signup} class="menu_btn_home menu_btn_home_inactive" type="type" maxlength="100" size="26">
						<br><br>
						<button class="menu_btn_home" style="height: 40px;" type="submit">
							<span  class="text-electric" on:click={ () => sendEmail() }>&nbsp; Get code &nbsp;</span>
						</button>
						</span>
						{/if}
					</td>
				</tr>
			</table>
			</center>
			{:else if show_mebot_trips }

			<center>
			<table width=330px valign=middle border=0>
			{#each mebot_trips as trip, i}
			<tr height=20px>
			<td align=left width=20px>
				{#if trip.land_img != null}
					<div class="message question no_tap_zoom" on:click={ () => { push('/habitat/2/' + trip.land_file_id) } }> &nbsp; <img src="{trip.land_img}" class="no_tap_zoom land_sm" style="user-select: none;" width=24px height=24px alt="Land42"></div>
				{:else}
					<div class="message question no_tap_zoom" on:click={ showMebotTrip }> &nbsp; <img data-card-id={i} src="{trip.img}" class="no_tap_zoom" style="user-select: none;" width=24px height=24px alt="Mebot"></div>
				{/if}
			</td>
			<td width=20px align=left valign=middle>
				<span style="display: flex; align-items:center; margin-bottom: 4px;" >
				<span class="text-electric" style="color:silver; margin-top: 0px;" >
				&nbsp;<span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=12px; alt=''></span>
				</span>
				<span class="text-electric-white">
				<div class="vitals-small text-glow " style=""> { numberWithCommas(trip.sparkles) } </div>
				</span>
				</span>
			</td>
			<td width=60px valign=top> <span class="vitals-small text-glow-blueish">{@html trip.info }</span> </td>
			<td width=40px align=right valign=top> <span class="vitals-small text-glow-gray">{trip.time_ago}</span> &nbsp;</td>
			</tr>
			{/each}
			</table>
			</center>

			{:else }

			{#if show_mebots }

			<br><br><br>
			{#each mebots as mebot, i}
				<div class="mebots-flip-box" >
				<div class="flip-box-inner">
				<div class="flip-box-front card">
					<div class="vertical-center" on:click={displayMebotDetails}>
							<div class="message question" transition:fade|local={{duration: 300}}> 
								<img data-card-id={i} src="{mebot.img}" width=100px alt="mebot">
								<div data-card-id={i} class="mebot-byline text-glow-blueish">
									{@html mebot.byline }
								</div>
								<div data-card-id={i} class="mebot-byline-small text-glow-blueish">
									{#if mebot.badges != null}
										{@html mebot.badges }
									{/if}
								</div>
							</div>
							<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
					</div>
				</div>
				</div>
				</div>
			{/each}

			{:else }

			{#if show_places }

			<br><br>

			{#if show_place_detail != -1 }

<!--			<div class="text-electric">Go visit some new Land42 locations!</div> -->

			{#if habitat_details != -1 }

			<center>
				<table width=330px border=0>
					<tr height=10px>
						<td width="50px" valign=middle align=center>
							<div class="text-electric" style="white-space: nowrap; font-size: 14px;" on:click={ () => { habitat_details = -1 }}>&nbsp; ✖️ &nbsp;&nbsp; </div>
						</td>
						<td colspan="2">&nbsp;</td>
					</tr>
					<tr>
						<td width="50px" valign=top align=center>
							<table height=250px border=0>

								<tr height=80px><td align=center valign=top>
								{#if false }
								<img class="land_sm" src={habitats[show_place_detail].url} width="22px" height=22px in:fade|local={{duration: 300}} style="margin-top: 10px;" alt="land42" on:click={ () => { push('/habitat/2/' + habitats[show_place_detail].file_id) }} />
								{:else}
								<img class="land_sm" src={habitats[show_place_detail].url} width="22px" height=22px in:fade|local={{duration: 300}} style="margin-top: 10px;" alt="land42" on:click={ () => { habitat_details = -1 }} />
								{/if}
								</td></tr>

								<tr height=100px><td align=center valign=top>
								</td></tr>

							</table>
						</td>
						<td width=200px height=250px align=center>

							<table border=0><tr><td>
							<center>
							<div class="text-electric" style="font-size: 14px; margin-bottom: 16px;">Habitat Structures</div>
							<div class="snake_row_inner_habitat" style="height: 50px;" >
									{#each h_sts as structure, i}
									<span class="habitat-facility" >
											<span >
												<div><span style="font-size: 22px;">{ structure.em }</span></div>
											</span>
									</span>
									{/each}
									{#if h_sts.length == 0 && !is_mayor }
									<span class="habitat-facility" >
										<span >
											<div><span style="font-size: 10px;">➖</span></div>
										</span>
									</span>
									{/if}

									{#if is_mayor == 1 }
									{#if h_sts.length == 0 }
									<button class="menu_btn_home build_active" on:click={ canBuildStructure } style="height: 36px;">
										<span class="leaderboard" >
											<span  style="display: flex; align-items:center; justify-content: center; margin-top: 4px; height: 20px;" >
												&nbsp; Build&nbsp;🏗️&nbsp;
											</span>
										</span>
									</button>
									{:else}
									<span class="habitat-facility" >
										<span >
											<div style="font-size: 18px;" class="plus-pulsing1" on:click={ canBuildStructure }>➕</div>
										</span>
									</span>
									{/if}
									{/if}

							</div>
							<div class="text-electric" style="font-size: 14px; margin-top: 0px; margin-bottom: 10px;">
								{#if h_settlers.length > 0 }
								Settlers & Visitors<!-- ({h_settlers_count}) -->
								{/if}
							</div>
							<div class="snake_row_inner_habitat_settler" style="height: 100px;" >
								{#if h_settlers.length == 0 }
								<span class="text-electric" style="font-size: 14px; margin-top: 10px; margin-bottom: 10px;">
								No settlers yet
								{#if !is_mayor }
								<!-- Be the first and help grow this habitat. -->
								{/if}
								</span>
								{/if}

									{#each h_settlers as settler, i}
									<span class="habitat-settler" class:settler_active={ settler.s == 1 } class:mayor_active={ settler.id == hab_mayor_id } on:click={() => displaySettlerVisitor(settler.img_url, settler.s == 1, settler.id == hab_mayor_id) }>
										<img src={ settler.img_url } width="18px"  alt="Mebot" />
									</span>
									{/each}
							</div >
							<div style="height: 40px;" >

										{#if is_own == 0 && is_settled == 0 && chain_id > 0 }
										<button class="menu_btn_home" on:click={() => displaySettleHere( habitats[show_place_detail].name, 500 ) }>
											<span class="leaderboard" >
												<span class="text-electric" style="display: flex; align-items:center; justify-content: center; margin-top: 4px;" >
													<img src={ my_mebot_img_url } width="22px" style="margin-left: 6px; margin-right: 2px;" alt="Mebot" />
													&nbsp; Settle here &nbsp;
												</span>
											</span>
										</button>
										{/if}

							</div>
							</center>
							</td></tr></table>

						</td>
						<td width="50px" align=center valign=top>
							<table height=250px border=0>

							<tr height=50px><td align=center valign=top>
							{#if mayor_mebot_img_url != null }
								<img src={mayor_mebot_img_url} width="24px" height=24px in:fade|local={{duration: 300}} style="margin-top: 10px;" alt="Mayor mebot" on:click={ displayMayor }/>
							{:else}
								<img src='/img/pixel.png' width=24px height=24px alt='mebot'>
							{/if}

							</td></tr>

							<tr height=50px><td align=center valign=middle>
							<div style="margin-top: 5px;">
							{#if is_mayor == 0 && mayor_mebot_img_url != null }
							<div class="controls" class:like-pulsing={ liking } in:fade|local={{duration: 300}} on:click={ favHabitat(habitats[show_place_detail].id) }>
								{#if (is_fav_hab == 1) }
									💛
								{:else}
									🤍
								{/if}
							</div>
							{/if}
							</div>
							</td></tr>

							<tr height=50px><td align=center valign=bottom>
								{#if is_settled == 1 && my_mebot_img_url != null }
									<img src={my_mebot_img_url} width="24px" height=24px in:fade|local={{duration: 300}} style="margin-top: 10px;" alt="Settled mebot" on:click={ displayMySettled }/>
								{:else}
									<img src='/img/pixel.png' width=24px height=24px alt='mebot'>
								{/if}
							</td></tr>

							</table>
						</td>
					</tr>
					<tr>
						<td width="50px" valign=top align=center>
							&nbsp;
						</td>
						<td align=center><span class="text-electric" style="font-size: 14px;">
							<!--{ habitats[show_place_detail].name }-->
						</span></td>
						<td width="50px" valign=middle align=center>
							&nbsp;
						</td>
					</tr>
				</table>
			</center>

			{:else }

			{#if is_building == true }

			<center>
				<table width=330px border=0 height=40px>
					<tr height=10px>
						<td width="50px" valign=middle align=center>
							<div class="text-electric" style="white-space: nowrap; font-size: 14px;" on:click={ () => { is_building = false } }>&nbsp; ✖️ &nbsp;&nbsp; </div>
						</td>
						<td colspan="2">&nbsp;</td>
					</tr>
					<tr width=290px height=300px>
						<td colspan=3 width=290px height=250px valign=middle align=center>

							<div class="snake_row_inner" style="height: 300px;" >
									{#each structures as structure, i}
									<div class="build-flip-box" >
									<div class="flip-box-inner">
									<div class="flip-box-front build-card">
										{#if (structure.class == 10) }
										<button class="menu_build_bh build_active_bh" style="width: 48px;" on:click={() => displayBuildStructure(i)}>
											<span class="leaderboard"  >
												<div><span style="font-size: 20px;">{ structure.em }</span></div>
												 <span class="text-electric" style="font-size: 8px;"> { structure.short_name }</span> 
											</span>
										</button>
										{:else}	
										<button class="menu_build" class:build_active={ structure.is_built == 0 } style="width: 48px;" on:click={() => displayBuildStructure(i)}>
											<span class="leaderboard"  >
												<div><span style="font-size: 20px;">{ structure.em }</span></div>
												 <span class="text-electric" style="font-size: 8px;"> { structure.short_name }</span>
											</span>
										</button>
										{/if}
									</div>
									</div>
									</div>
									{/each}
							</div>
						</td>
					</tr>
					<tr>
						<td width="50px" valign=top align=center> 
							&nbsp;
						</td>
						<td align=center><span class="text-electric-active" style="font-size: 14px;">Build at &nbsp;</span><span class="text-electric" style="font-size: 14px;">{ habitats[show_place_detail].name }</span></td>
						<td width="50px" valign=middle align=center> 
							&nbsp;
						</td>
					</tr>
				</table>
			</center>

			{:else }

			<center>
				<table width=330px border=0>
					<tr height=10px>
						<td width="50px" valign=middle align=center>
							<div class="text-electric" style="white-space: nowrap; font-size: 14px;" on:click={ displayPlaces }>&nbsp; ✖️ &nbsp;&nbsp; </div>
						</td>
						<td colspan="2">&nbsp;</td>
					</tr>
					<tr>
						<td width="50px" valign=middle align=center>
						{#if true }

						{#if is_mayor == 1 || h_sts.length > 0 }
						<span in:fade|local={{duration: 300}} >

						{#each h_sts.slice(0, 3) as structure, i}
							<div style="margin-bottom: 8px;" on:click={ viewHabitatDetails(show_place_detail) }> { structure.em } </div>
						{/each}
						{#if h_sts.length > 3 }
							<div style="margin-bottom: 8px;" > ... </div>
						{/if}

						{#if is_mayor == 1}
						<div style="margin-top: 14px; margin-bottom: 24px;" class="plus-pulsing" on:click={ canBuildStructure }>➕</div>
						{/if}

						</span>
						{/if}

						{/if}

						</td>
						<td width=200px height=180px align=center>
							<div class="text-electric" style="font-size: 65px; padding: 0;" in:fade|local={{duration: 300}} on:click={ viewHabitatDetails(show_place_detail) }>
								<img  class="habitat_lg" class:hab_lg_active={ habitats[show_place_detail].id == cur_hab_id } width=160px height=160px alt="land42" src="{habitats[show_place_detail].url}">
							</div>
						</td>
						<td width="50px" align=center valign=top>
							<table height=180px border=0>

							<tr height=50px><td align=center valign=top>
							<!--<div style="font-size:10px;" on:click={ displayMayor }>👑</div>-->
							{#if mayor_mebot_img_url != null }
								<img src={mayor_mebot_img_url} width="24px" height=24px in:fade|local={{duration: 300}} style="margin-top: 10px;" alt="Mayor mebot" on:click={ displayMayor }/>

								<!--
								{#if h_tags.length > 0 }
								<div style="margin-top: 5px;" on:click={ displayTags }>
									🏷️
								</div>
								<div style="margin-top: 5px;" on:click={ displayTreasure }>
									🏴‍☠️
								</div>
								{/if}
								-->

							{:else}
								<img src='/img/pixel.png' width=24px height=24px alt='mebot'>
							{/if}

							</td></tr>

							<tr height=50px><td align=center valign=center>
							<div style="margin-top: 5px;">
							{#if is_mayor == 0 && mayor_mebot_img_url != null }
							<div class="controls" class:like-pulsing={ liking } in:fade|local={{duration: 300}} on:click={ favHabitat(habitats[show_place_detail].id) }>
								{#if (is_fav_hab == 1) }
									💛
								{:else}
									🤍
								{/if}
							</div>
							{/if}
							</div>
							</td></tr>

							<tr height=50px><td align=center valign=bottom>
								{#if is_settled == 1 && my_mebot_img_url != null }
									<img src={my_mebot_img_url} width="24px" height=24px in:fade|local={{duration: 300}} style="margin-bottom: 20px;" alt="Settled mebot" on:click={ displayMySettled }/>
								{:else}
									<img src='/img/pixel.png' width=24px height=24px alt='mebot'>
								{/if}
							</td></tr>

							</table>
						</td>
					</tr>
					<tr>
						<td width="50px" valign=top align=center>
							&nbsp;
						</td>
						<td align=center valign=middle >
							<a href={'#/habitat/2/' + habitats[show_place_detail].file_id}>
							<button class="menu_btn_home menu_btn_home_inactive" style="padding-top: 7px;"><span class="text-electric" style="font-size: 14px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"> &nbsp; { habitats[show_place_detail].name } ➡️ &nbsp; </span></button>
							</a>
						</td>
						<td width="50px" valign=middle align=left>
							{#if h_tags.length > 0 || is_mayor == 1 || h_count > 0 }
							<div style="position: relative; padding-bottom: 8px;" on:click={ displayTags }>
								&nbsp;&nbsp; 🏷️
								{#if h_count > 0 }
								<span class="tag__badge">{ h_count }</span>
								{/if}
							</div>
							{/if}
						</td>
					</tr>
				</table>
			</center>

			{/if}
			{/if}

			{:else }

			<center>
				<table width=330px border=0 height=40px>
					<tr>
						<td colspan=2 align="center">
							<span style="white-space: nowrap;">
							&nbsp;
							<button class="menu_btn_home" class:submenu_active={ (filter_pl_def == 1) } on:click={() => getHabitats(1)}>
								<span class="leaderboard" >
									&nbsp; <span class="text-electric"> 🏃‍♂️ Today</span> &nbsp;
								</span>
							</button>
							&nbsp; &nbsp;
							<button class="menu_btn_home" class:submenu_active={ (filter_pl_def == 2) } on:click={() => getHabitats(2)}>
								<span class="leaderboard" >
									&nbsp; 👑 <span class="text-electric"></span> &nbsp;
								</span>
							</button>
							&nbsp; &nbsp;
							<button class="menu_btn_home" class:submenu_active={ (filter_pl_def == 3) } on:click={() => getHabitats(3)}>
								<span class="leaderboard" >
									&nbsp; 📍 <span class="text-electric"> </span> &nbsp;
								</span>
							</button>
							&nbsp; &nbsp;
							<button class="menu_btn_home" class:submenu_active={ (filter_pl_def == 4) } on:click={() => getHabitats(4)}>
								<span class="leaderboard" >
									&nbsp; 💛 <span class="text-electric"> </span> &nbsp;
								</span>
							</button>
							&nbsp; &nbsp;
							<button class="menu_btn_home" style="position: relative;" class:submenu_active={ (filter_pl_def == 5) } on:click={() => getHabitats(5)}>
								<span class="leaderboard" >
									&nbsp; <span class="text-electric">All</span> &nbsp;
								</span>
								{#if badge_n[0] > 0 }
								<span class="habitat__badge">{ show_badge_n(0) }</span>
								{/if}
							</button>
							</span>
						</td>
					</tr>
					<tr width=290px height=160px>
						<td colspan=2 width=290px height=250px valign=middle align=center>

							{#if is_loading == false && habitats.length == 0 && !(show_claim && show_places_today) }

							<center><span class="text-electric">{@html habitats_empty }</span></center>

							{:else }
							<div class="snake_row_inner" style="height: 150px;" >
									{#each habitats as place, i}
									<div class="habitat-flip-box" in:fade|local={{duration: 300}}>
									<div class="flip-box-inner">
									<div class="flip-box-front habitat-card">
										<div on:click={displayPlaceDetails} style="position: relative;">
											<div class="text-electric" style="font-size: 26px;" > <div ><img class="habitat_sm" class:hab_active={ place.id == cur_hab_id && filter_pl_def != 5 } class:hab_active-not-seen={ place.s == -1 } data-card-id={i} width=60px height=60px alt="land42 habitat" src="{place.url}"></div> </div>
											{#if false  }
											{#if place.st_n >= 1 }
											<span class="habitat__badge_st"> {place.st_n} </span>
											<span class="habitat__badge_se2"> 2 </span>
											{:else}
											<span class="habitat__badge_se1"> 2 </span>
											{/if}
											{/if}
										</div>
									</div>
									</div>
									</div>
									{/each}

									{#if show_claim && show_places_today}
									<div class="habitat-flip-box" >
										<button class="menu_btn_claim" class:claim_active={ show_claim } on:click={() => displaySetupHabitat()}>
										<span class="leaderboard"  >
											<span class="text-electric"> 📍 Setup <br> &nbsp;&nbsp; Habitat</span> &nbsp;
										</span>
										</button>
									</div>
									{/if}
							</div>
							{/if}
						</td>
					</tr>
					<tr height=50px width=330px>
						{#if show_places_today }

						<td align="left">&nbsp;&nbsp;<span class="text-electric" style="font-size: 12px; white-space: nowrap;" on:click={ displayHabitatsToday } >☀️ { hab_visited_today } </span></td>
						<td align="right"> <span class="text-electric" style="font-size: 12px; white-space: nowrap;" on:click={ displayParsecDetails } >🏃‍♂️ <span style="font-size: 10px;"> { total_dist_in_square } </span> &nbsp;</span></td>

						{:else }

						<td colspan=2 width=330px align=center>
							{#if is_loading == false }
							<span class="text-electric" style="font-size: 14px;">{@html habitat_msg }
								{#if (true && filter_pl_def == 3) }
								<a href="/#/map/2/1">
									&nbsp;<button class="menu_btn_home" style="padding-top: 7px;"><span class="text-electric" style="font-size: 14px; ">&nbsp; 🗺️ Map &nbsp;</span></button>
								</a>
								{/if}
							</span>
							{/if}
						</td>

						{/if}
					</tr>
				</table>
			</center>

			{/if}

			{:else }

			{#if show_artifacts }

			{#if artifacts.length > 0 }

			{#if show_artifact_detail != -1 }

			<center>
			<table width=330px border=0>
				<tr>
					<td width="50px" valign=top allign=center> 
						<br> 
						<div class="text-electric" style="white-space: nowrap; font-size: 14px;" on:click={ displayArtifacts }> &nbsp; &nbsp; ✖️ </div> </td>
					<td width=200px align=center>
						<br>
						<span class="text-electric" style="font-size: 16px;"> {@html artifacts[show_artifact_detail].title} </span> <span class="text-electric-grey"></span> <br><br><br>
						<div class="text-electric" style="font-size: 60px;" in:fade|local={{duration: 300}}>
							<div style="position: relative; width: 100px;">
								<div> {@html artifacts[show_artifact_detail].em} </div>
								{#if artifacts[show_artifact_detail].n > 1 }
									<span class="artifact__badge_lg"> {artifacts[show_artifact_detail].n} </span>
								{/if}
							</div>
						</div>
						<div class="text-electric"> {@html artifacts[show_artifact_detail].desc} </div>

						<br><br>
						<button class="submenu_active tooltip1" style="padding: 6 0px; font-size: 16px;" on:click={ () => sellArtifact( artifacts[show_artifact_detail].sell ) }> &nbsp; Sell &nbsp; </button>

					</td>
					<td width="50px"><div class="text-glow" style="white-space: nowrap; font-size: 20px;">
					</td>
				</tr>
			</table>
			</center>

			{:else }

			<div class="main1" on:scroll="{ () => loadOnArtifactScroll(document.querySelector('.main1')) }">

			<center>
			<table width=330px border=0 height=30px>
				<tr>
					<td width="30px" valign=top allign=center> <div class="text-electric"> &nbsp; </div> </td>
					<td width=200px align=center>
						<br><div class="text-electric" style="font-size: 16px;"> Artifacts 🚩 </div><br><br>
					</td>
					<td width="30px"><div class="text-glow" style="white-space: nowrap; font-size: 20px;"> &nbsp; </div> </td>
				</tr>
			</table>

			<div class="snake_row">
			{#each artifacts as artifact, i}

				<div class="artifact-flip-box" >
				<div class="flip-box-inner">
				<div class="flip-box-front artifact-card">
					<div class="vertical-center" style="position: relative;" on:click={displayArtifactDetails}>
						<div class="text-electric" style="font-size: 28px;" transition:fade|local={{duration: 300}}> <div data-card-id={i}>{ artifact.em }</div> </div>
						{#if artifact.n > 1 }
						<span class="artifact__badge"> {artifact.n} </span>
						{/if}
					</div>
				</div>
				</div>
				</div>

			{/each}
			</div>

			<div class="loader" use:loader={artifact_loading}>
			<br><br><br><br><br><br>
			<br><br><br><br><br><br>
			<br><br><br><br><br><br>

			</center>
			</div>

			{/if}

			{:else }
				<div class="text-electric">No artifacts 🚩 <br> 🚶‍♂️ Visit habitats today and find some!</div>
			{/if}

			{:else }
			{#if !show_details }
				<!--<div
					href="/#/move/{dash_token}/{m_id}"
					style="user-select: none;"
				>-->
				<div>
					<center>
				<table width=330px height=266px border=0>
					<tr>
<!--					<td width=10px align=center valign=bottom>
						&nbsp;
					</td>-->
					<td width=20px align=center valign=top>
						<div style="height: 28px;">&nbsp;</div>

						{#if mebot_mood != '' }
						<div on:click={ showMood } class="text-activate-plain" style="font-size: 28px;">
							{@html mebot_mood}
						</div>
						{/if}

						{#if can_chat == 1 }
						<div>
						<a href="/#/chat/2/1">
							<div style="margin-top: 2px; margin-top: 16px; position: relative;" class="text-electric text-green submenu_active tooltip1">
								{#if chat_n != '' }
								<span class="chat__badge"> { chat_n } </span>
								{/if}
								&nbsp;💬&nbsp;<br>
								<span style="font-size: 10px;">Chat</span>
							</div>
						</a>
						</div>
						{/if}

						{#if has_egg_to_hatch_i > -1}
						<br>
						<div on:click={ showEggToHatch } style="margin-bottom: 0px; ">
							<span class="text-electric-egg" style="font-size: 18px;">🥚</span>&nbsp;<br>
						</div>
						{/if}

						&nbsp;&nbsp;&nbsp;
					</td>
					<td width=220px height=250px align=center>
					<div in:animateIn style="user-select: none;">
					<img style="user-select: none;"
						on:click={() => displayDash()}
						src={mebot_img_url}
						width="220px"
						alt="Your Mebot"
					/>
					</div>
					</td>
					<td width=20px align=center valign=top>
						<div style="height: 24px;">&nbsp;</div>
						<div on:click={() => displayWatts()} style="margin-bottom: 0px; ">
							<span class="text-activate" style="font-size: 22px;">⚡</span><br>
							<span class="text-activate-plain" style="font-size: 15px;"> { watts_score } </span>
							<br><br>
						</div>

						<div on:click={displayMoonPhaseDetails} style="margin-bottom: 0px;">
							{ moon_phase(mebot_moon_phase) }
						</div>
						<div on:click={displayStepDetails} style="margin-top: 22px;" class="text-electric text-green submenu_active tooltip1">
							&nbsp;👟&nbsp;<br>
							<span style="font-size: 10px;">{ today_n }</span>
						</div>
						{#if ($progress > 0) }
						<div class="outer">
							<div class="progress_inner" style="width: {$progress * 100}%; margin-top: 5px;" ></div>
						</div>
						{/if}
						<div on:click={displayMebotClass} style="margin-top: 22px;">
							{ display_mebot_class(mebot_class_id) }
						</div>

						{#if true }

						{#if cur_hab_url == 'test' }
						<br>
						<button class="menu_btn_mebots" style="position: relative; background-size: 25px; background-image: url({cur_hab_url}); background-repeat: no-repeat; background-position: center;" class:menu_active={ (show_places) } on:click={showPlaces}>
						</button>
						{/if}

						{/if}
<!--						<div style="margin-bottom: 5px;">
							👽
						</div>
						<div style="margin-bottom: 5px;">
							🧪
						</div>-->
					</td>
					</tr>
				</table>
				<table width=330px height=20px border=0>
				<tr>
					<td align=left valign=bottom>
						<div class="menu_btn_help menu_btn_clear" style="position: relative;" on:click={() => showCityGuilds()}>
							<span class="leaderboard" >
								&nbsp; <span class="text-electric"> {@html city_guilds } </span> &nbsp;
							</span>
						</div>
					</td>
					<td align=right>
						<table border=0>
							<tr><td on:click={ copySocial }>{@html qr_img_tag }</td></tr>
							<tr><td align=center><div style="margin-top: 0px;">
								<button class="submenu_active tooltip1" style="padding: 6 0px; font-size: 16px;" class:copy-pulsing={ copied } on:click={ copySocial }> &nbsp;⇧&nbsp; </button>
							</div></td></tr>
							<tr><td align=center><div class="header-text" on:click={ copySocial }>Invite</div></td></tr>
						</table>
					</td>
				</tr>
				</table>
				<table width=330 border=0>
					<tr height=30px width=330 valign=top>

						{#if journey['info'] != '' }
						<td colspan=2 width=120px align="left" on:click={ showJourney } >
							{@html journey['info'] }
						</td>
						{:else}
						<td colspan=2 align="left" valign=middle>&nbsp;&nbsp;<span class="text-electric" style="font-size: 12px; white-space: nowrap;" on:click={ goHabitatsToday } >☀️ <span in:fade|local={{duration: 200}}>{ hab_visited_today }  </span> </span></td>
						{/if}

						<td align=right valign=middle width=80px on:click={ displayParsecDetails }><div style="white-space: nowrap;">&nbsp; ⚡ &nbsp;</div></td>
						<!--<td valign=middle> <span class="mebot-byline text-green">↔️</span> </td>-->
						<td width=80px valign=middle align=left on:click={ displayParsecDetails }>

							<div style="width: 80px;">
							{#if ($daily_power >= 0) }
							<div class="outer_daily_power">
								<div class="progress_inner_daily_power" style="width: {$daily_power * 100}%; margin-top: 4px; margin-bottom: 5px;" ></div>
							</div>
							{/if}

							<div class="text-green" style="margin-top: 4px; font-size: 10px;">
								<span style="color: white;">Available:</span> { power_avail }
							</div>
							</div>
						</td>
					</tr>
				</table>

				<table>
					<tr><td>
						<input size="1" type="text" id="social_link" bind:value={social_link} disabled style="visibility: hidden;">
					</td></tr>
				</table>

				</center>
				</div>
				<!--</div>-->
			{:else }
			<div in:fade|local style="user-select: none;">
				<!--  <a href="/#/match4/{dash_token}/{m_id}">-->
				<table width=330px border=0>
				<tr>
				<td width=50px align=center>
				</td>
				<td width=200px align=center>

					{#if m_id > 0}
					<img in:animateIn1|local style="user-select: none; touch-action: none;"
						on:click={() => {if (is_hatched == 1 || m_id > 10000) push('/stats/' + dash_token + '/' + m_id + '/' + active_m_id) } }
						src={mebot_img_url}
						width="100px"
						alt="mebot"/><br>
					{/if}
					{#if is_hatched == 1 && is_active == 1 }
					<button class="menu_btn_activated mebot-active1 menu_active" disabled>
						<span class="leaderboard" style="white-space: nowrap;">
							&nbsp; <span class="text-activate "> Active </span> &nbsp;
						</span>
					</button>
					{:else if is_hatched == 0 && is_hatching == 1}
					<button class="menu_btn_activated" disabled>
						<span class="leaderboard" style="white-space: nowrap;">
							&nbsp;&nbsp; <span class="text-electric text-activate"> Hatching 🐣</span> &nbsp;
						</span>
					</button>
					{:else if m_id > 0 && chain_id > 0}
					<button class="menu_btn_upgrade" on:click={processActivationHatch}>
						<span class="leaderboard" style="white-space: nowrap;">
							&nbsp; <span class="text-electric"> { (is_hatched == 1) ? 'Activate' : (is_hatching == 1) ? 'Hatching 🐣' : 'Hatch egg' }</span> &nbsp;
						</span>
					</button>
					{#if is_hatched != 1 }
					<center>
						&nbsp; <span class="text-electric" style="font-size: 14px;"> <b>Gen-0</b> </span> &nbsp;<br>
						&nbsp; <span class="text-electric" style="font-size: 14px;"> {mtype} </span> &nbsp;<br><br>
						<button class="tooltip" style="white-space: nowrap;" on:click={ showWattLevelInfo }>&nbsp; 👉 &nbsp;Hatching Guide &nbsp;</button> 
					</center>
					{/if}
					{:else }
					<center>
					&nbsp; <span class="text-electric" style="font-size: 14px; white-space: nowrap;"> <b>Mebot ghost 👻</b></span> &nbsp;<br>
					&nbsp; <span class="text-electric" style="font-size: 10px;"><br> Discover new habitats, earn ✨ 💎<br> <a href="{page_url}" style="color: white; text-decoration: underline;">Get Gen-0 Mebot</a> </span> &nbsp;
					</center>
					{/if}

				</td>
				<td width=50px colspan="2"></td>
				</tr>

				{#if is_hatched == 1 }
				<tr height=10px><td align=left> <div class="vitals2 text-glow" style="">&nbsp;⚡ &nbsp;Watt Level</div></td>
					<td align=center valign=bottom> <div class="vitals2 text-glow" style=""><b>{ watt_level }</b></div></td>
					<td colspan="2"></td></tr>
				<tr height=10px><td align=left> <div class="vitals2 text-glow" style=""> <span style="white-space: nowrap;" >&nbsp;🧭 &nbsp;Autopilot </span></div></td>
					<td align=center valign=middle> <div class="vitals2 text-glow" style=""><b>{ autopilot_level }</b></div> </td>
					<td colspan="2">
						{#if autopilot_level < 10 }
						<button class="menu_btn_upgrade" on:click={autopilotUpdate}>
							<span class="leaderboard" style="white-space: nowrap;">
								&nbsp; <span class="text-electric"> Upgrade </span> &nbsp;
							</span>
						</button>
						{/if}
					</td></tr>
				<tr height=10px><td align=left> <div class="vitals2 text-glow" style=""><span style="white-space: nowrap;" >&nbsp;👟 &nbsp;Trips taken </span></div></td>
					<td align=center valign=middle > <div class=" text-glow-blueish" style="" on:click={() => showMebotTrips(active_m_id)}><b>{ numberWithCommas(trips) }</b></div> </td>
					<td width=10px align=right on:click={displayAutoWalk}>🤖&nbsp;</td>
					<td align=left width=70px >
						<span class="text-electric info" style="white-space: nowrap;" >
							<SwitchSmall bind:checked={auto_walk}></SwitchSmall>
						</span>
					</td>
				</tr>
				{:else if minted != '' }
				<tr> <td colspan=4>
				<table>
				<tr height=10px><td align=left colspan=2> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;⏰ &nbsp;Start:</div></td>
					<td align=right colspan=2> <div class="vitals2 text-glow" style="white-space: nowrap;">{ minted }</div> </td>
				</tr>
				<tr height=10px><td align=left colspan=2> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;🐣&nbsp; Will hatch:</div></td>
					<td align=right colspan=2> <div class="vitals2 text-glow" style="white-space: nowrap;">{ hatched }</div> </td>
				</tr>
				<tr height=10px><td align=left colspan=2> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;⚡ &nbsp;Current level:</div></td>
					<td align=right colspan=2>
						<div class="vitals2 text-glow" style="white-space: nowrap;" on:click={() => showWattLevelInfo()}>
							&nbsp; <span class="text-electric">Watt Level: { user_watt_level } </span>
						</div>
					</td>
				</tr>
				<tr height=10px>
					<td align=center colspan=4>
						<div class="vitals2 text-glow" style="">&nbsp;
							<span class="text-electric" style="font-size: 10px; margin-bottom: 10px;">❗❗ <!--Invite friends to increase your Mebot's hatch Watt Level-->  <button class="tooltip" on:click={() => showWattLevelInfo()}>&nbsp; 👉 &nbsp;View Hatching Guide &nbsp;</button> </span>
						</div>
					</td>
				</tr>
				</table>
				</td></tr>
				{/if}
                    <!--<tr height=34px><td align=left valign=middle> <span style="display: flex; align-items:center;" >
                        &nbsp;<span class="text-electric" style="color:silver; margin-top: 4px;" ><span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=24px; alt=''></span></span>
                        <span  class="text-electric-white" > <div class="vitals1 text-glow" style=""> &nbsp;Balance </div> </span>
                        </span>  </td><td align=center> <div class="vitals1 text-glow" style="">{ numberWithCommas(sparkles) }</div> </td>
						<td valign=bottom>
						</td>
					</tr>-->
<!--				<tr height=34px><td align=left> <div class="vitals1 text-glow" style=""><span style="white-space: nowrap;" >&nbsp;𒀛 &nbsp;Collected  </span></div></td>
					<td align=center> <div class="vitals1 text-glow" style="">{ numberWithCommas(trips) }</div> </td>    <td></td></tr>
-->
				</table>
			</div>
			{/if}
			{/if}
			{/if}
			{/if}
			{/if}
		</div>
	</center>
	<center>
	{#if !(show_places || !show_details) }
	<div class="small_row" />
		<img
			style="border:none; margin-top: 10px; -webkit-tap-highlight-color: transparent;"
			src="/img/vitals-mebots-m.png"
			width="300px"
			height="53px"
			alt="meebot"
			usemap="#exercise"
		/>
		<map name="exercise" style="user-select: none; -webkit-tap-highlight-color: transparent;">
			<area shape="rect" coords="0, 0, 50, 106" alt="Watt Score"
				href="/#/leaderboard/{dash_token}/{m_id}/1"
				style="user-select: none; -webkit-tap-highlight-color: transparent;" />
			<area shape="rect" coords="50, 0, 95, 106" alt="Steps"
				href="/#/leaderboard/{dash_token}/{m_id}/2" />
			<area shape="rect" coords="96, 0, 135, 106" alt="Explorer"
			   href="/#/leaderboard/{dash_token}/{m_id}/3" />
			<area shape="rect" coords="136, 0, 180, 106" alt="Heart"
			   href="/#/leaderboard/{dash_token}/{m_id}/4" />
			<area shape="rect" coords="181, 0, 220, 106" alt="Sleep"
			   href="/#/leaderboard/{dash_token}/{m_id}/5" />
			<area shape="rect" coords="221, 0, 270, 106" alt="Social"
			   href="/#/leaderboard/{dash_token}/{m_id}/6" />
			<area shape="rect" coords="270, 0, 300, 106" alt="Brain"
			   href="/#/leaderboard/{dash_token}/{m_id}/7" />
		</map>
		<div>
			<table border="0" width="300px">
				<tr>
					<td width="40px">
						<div style="user-select: none; -webkit-tap-highlight-color: transparent;" on:click={ loadHealthData(m_id, 0) }>
							<div
								id="vitals1"
								class="vitals_bold text-glow"
								style=""
								class:text-electric={ stat_type == 0 }
							>
								{watts_score}
							</div>
						</div>
					</td>
					<td width="40px" align="center">
						<div on:click={ loadHealthData(m_id, 1) }>
							<div id="vitals2" class="vitals text-glow" class:text-electric={ stat_type == 1 }>
								{steps}%
							</div>
						</div>
					</td>
					<td width="34px" align="center">
						<div on:click={ loadHealthData(m_id, 2) }>
							<div id="vitals3" class="vitals text-glow" class:text-electric={ stat_type == 2 }>
								{explorer}%
							</div>
						</div>
					</td>
					<td width="36px" align="center">
						<div on:click={ loadHealthData(m_id, 3) }>
							<div id="vitals4" class="vitals text-glow" class:text-electric={ stat_type == 3 }>
								{hrv}%
							</div>
						</div>
					</td>
					<td width="38px" align="center">
						<div on:click={ loadHealthData(m_id, 4) }>
							<div id="vitals5" class="vitals text-glow" class:text-electric={ stat_type == 4 }>
								{sleep}%
							</div>
						</div>
					</td>
					<td width="34px" align="center">
						<div on:click={ loadHealthData(m_id, 5) }>
							<div id="vitals6" class="vitals text-glow" class:text-electric={ stat_type == 5 }>
								{social}%
							</div>
						</div>
					</td>
					<td width="34px" align="center">
						<div on:click={ loadHealthData(m_id, 6) }>
							<div id="vitals6" class="vitals text-glow" class:text-electric={ stat_type == 6 }>
								{braniac}%
							</div>
						</div>
					</td>
				</tr>

				<tr height=10px>
					<td colspan=7 align=center>
						<div style="margin-top: 15px;" on:click={ loadHealthData(m_id) }>
						<Line data={health_data} height={20} width={280} options={
							{
								responsive: false,
								maintainAspectRatio: false,
								plugins: { legend: false, tooltip: false },
								scales: { x: {display: false, grid: {display: false}}, y: {display: false, grid: {display: false}} }
							}
						}
						/>
						</div>
					</td>
				</tr>

				{#if social_link != ''}
				<tr height=10px>
					<td colspan=7 align=center>
					<br>
						<div class="vitals2 text-glow-electric" style="white-space: nowrap; font-size: 12px;"> Invite Friends ➡️
							<input size="10" type="text" id="social_link" bind:value={social_link} disabled>
							<button class="tooltip" class:copy-pulsing={ copied } on:click={ copySocial }> ⬆️ Copy </button>
							<a href="/#/leaderboard/{dash_token}/{m_id}/6">
								<button class="tooltip" on:click={ loadHealthData(m_id, 5) }>	✨ Bounty</button>
							</a>
						</div>
					</td>
				</tr>
				{/if}
	
			</table>
		</div>
	{/if}
	</center>
{/if}

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<Modal
        show={$modal1}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>

	.mebots-flip-box {
		background-color: transparent;
		width: 95px;
		height: 150px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}
	.card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.artifact-flip-box {
		background-color: transparent;
		width: 58px;
		height: 80px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}
	.artifact-card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.habitat-flip-box {
		background-color: transparent;
		width: 72px;
		height: 10px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}
	.habitat-card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.build-flip-box {
		background-color: transparent;
		width: 52px;
		height: 10px;
		margin: 0 0px 0px 6px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}
	.build-card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.habitat-facility {
		background-color: transparent;
		width: 26px;
		height: 10px;
		margin: 0 0px 0px 6px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

	.habitat-settler {
		width: 18px;
		margin: 0 0px 4px 4px;
		border: 0px solid #f1f1f1;

		border-radius: 8px;
		border: 0px solid rgb(83, 83, 83);
		background-color: rgba(174, 169, 5, 0.2);
		box-shadow: 0 3px 7px rgba(66, 192, 255, 0.177);

		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

	.snake_row {
		display: flex;
		flex-wrap: wrap;
		width: 330px;
		height: 300px;
		justify-content: center;
		margin-bottom: 10px;
	}
	.snake_row_inner {
		display: flex;
		flex-wrap: wrap;
		width: 290px;
		height: 150px;
		justify-content: flex-start;
		margin-top: 10px;
	}
	.snake_row_inner_habitat {
		display: flex;
		flex-wrap: wrap;
		width: 180px;
		justify-content: center;
		margin-top: 10px;
	}
	.snake_row_inner_habitat_settler {
		display: flex;
		flex-wrap: wrap;
		width: 180px;
		justify-content: center;
		align-content: center;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
		width: 350px;
		margin-bottom: 10px;
		margin-left: 44px;
		margin-right: 36px;
	}

	.text-glow {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: white;
	}

	.text-glow-blueish {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}

	.text-glow-gray {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: rgba(255, 255, 255, 0.465);
	}

	.vitals_bold {
		color: white;
		font-size: 24px;
	}

	.vitals_mid {
		color: white;
		font-size: 20px;
	}

	.vitals {
		color: white;
		font-size: 14px;
	}
	.vitals1 {
		color: white;
		font-size: 16px;
	}
	.vitals-small {
		font-size: 12px;
	}
	.mebot-byline {
		font-size: 10px;
	}
	.mebot-byline-small {
		font-size: 6px;
	}
	.vitals2 {
		color: white;
		font-size: 14px;
	}

	.steps {
		color: rgb(255, 251, 0);
		font-size: 14px;
	}

	a {
		-webkit-tap-highlight-color: transparent;
	}

	.menu_btn_mebots {
		font-size: 14px;
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 6px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.menu_active {
		background-color: #2ffff1d6;
        box-shadow: 0 5px 15px rgb(231, 247, 255);
    }

	.land_sm {
		border-radius: 5px;
	}

	.controls {
		font-size: 12px;
		margin-bottom: 15px;
	}

	.menu_btn_upgrade {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.menu_btn_activated {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
	}

	.leaderboard {
		font-size: 12px;
	}
	.text-electric {
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}
	.text-electric-active {
		text-shadow: 0 0 32px rgba(255, 253, 192, 0.9),
			0 0 32px hsla(0, 0%, 97%, 0.98);
		font-family: arial;
		color: hsla(0, 0%, 97%, 0.794);
	}
	.text-green {
		color: #1bffe8ee;
	}

	.mebot-active {
		background-color: #42fff97d;
	}

	.text-activate-plain {
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px #42fff9fa;
		font-family: arial;
		color: hsl(0, 0%, 100%);
	}
	.text-activate {
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px #42fff9fa;
		font-family: arial;
		color: hsl(0, 0%, 100%);
		animation: text-activate-pulse 0.4s;
	}
	@keyframes text-activate-pulse {
	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(249, 255, 252, 0.98);
		font-family: arial;
		color: hsl(0, 0%, 96%);
	}

	10% {
		text-shadow: 0 0 62px rgba(255, 248, 192, 0.9),
			0 0 15px rgba(249, 255, 65, 0.98);
		color: hsl(0, 0%, 100%);
	}

	40% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(242, 255, 249, 0.98);
		font-family: arial;
		color: hsl(0, 0%, 100%);
	}

	90% {
		text-shadow: 0 0 52px rgba(255, 248, 192, 0.9),
			0 0 15px rgba(249, 255, 65, 0.98);
		color: hsl(0, 0%, 100%);
	}

	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(249, 255, 252, 0.98);
		font-family: arial;
		color: hsl(0, 0%, 96%);
	}
	}

    .mebot-active1 {

        background: linear-gradient(114deg, #42fff91e, #42e3ff, #42e3ff51);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 4s ease infinite;
		-moz-animation: AnimationName 4s ease infinite;
		-o-animation: AnimationName 4s ease infinite;
		animation: AnimationName 4s ease infinite;

		@-webkit-keyframes AnimationName {
			0%{background-position:0% 71%}
			50%{background-position:100% 30%}
			100%{background-position:0% 71%}
		}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

	* {
		touch-action: manipulation;
    }

	.no_tap_zoom {
		touch-action: manipulation;
	}

	.outer {
		margin: 0px;
		background-color: transparent;
		border: 0px;
	}

	.outer_daily_power{
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner, .outer {
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner {
		background-color: #1bffe8ee;
		display: block;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.progress_inner_daily_power {
		background-color: #1bffe8ee;
		display: block;
		box-shadow: 0 0 8px rgb(255, 255, 0), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

	.artifact__badge {
		background-color: rgb(0, 166, 181);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 6px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: 0;
		right: 2px;
	}

	.artifact__badge_lg {
		background-color: rgb(0, 166, 181);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 12px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -2px;
		right: 0px;
	}

	.mebots__badge {
		background-color: rgb(20, 20, 20);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
	}

	.habitat__badge_st {
		background-color: #2517bc;
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 10px rgb(0, 89, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: 50px;
		right: -3px;
	}
	.habitat__badge_se1 {
		background-color: #ac7800;
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 10px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: 50px;
		right: -3px;
	}
	.habitat__badge_se2 {
		background-color: #ac7800;
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 10px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: 50px;
		right: 11px;
	}

	.habitat__badge {
		background-color: #15c6b4;
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 10px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 12px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
	}

	.tag__badge {
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 8px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -4;
		right: 1;
	}

	.chat__badge {
  		background-color: rgb(12, 120, 253);
  		border-radius: 5px;
  		border: 0px solid white;
  		color: white;

  		padding: 2px 4px;
  		font-size: 12px;

  		position: absolute; /* Position the badge within the relatively positioned button */
  		top: -5px;
  		right: -8px;
	}

	.menu_btn_home {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.menu_btn_home_inactive {
		background-color: #6ce8fb44;
	}

	.menu_btn_claim {
		height: 60px;
		border-radius: 8px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}

	.submenu_active {
        background-color: #202020;
        box-shadow: 0 5px 15px rgb(231, 247, 255);
    }
    .habitat_lg {
        border-radius: 20px;
        box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
    }
	.hab_lg_active {
		box-shadow: 0 5px 15px rgb(231, 247, 255);
    }
    .habitat_sm {
        border-radius: 10px;
        box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
    }
	.hab_active {
		box-shadow: 0 5px 20px rgb(231, 247, 255);
    }
	.hab_active-not-seen {
		box-shadow: 0 10px 20px rgb(66, 192, 255);
    }

    .claim_active {

        background: linear-gradient(114deg, rgb(109, 34, 0), rgb(49, 19, 108), #42e3ff, #42e3ffee);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 2.5s ease infinite;
		-moz-animation: AnimationName 2.5s ease infinite;
		-o-animation: AnimationName 2.5s ease infinite;
		animation: AnimationName 2.5s ease infinite;
	}
	@-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

	.settler_active {
		border-radius: 8px;
		border: 0px solid rgb(83, 83, 83);
		background-color: rgba(174, 169, 5, 0.2);
		box-shadow: 0 3px 7px rgba(255, 252, 66, 0.64);
	}
	.mayor_active {
		border-radius: 8px;
		border: 0px solid rgb(83, 83, 83);
		background-color: rgba(174, 169, 5, 0.2);
		box-shadow: 0 3px 7px rgba(66, 192, 255, 0.893);
	}

	.menu_build {
		height: 75px;
		border-radius: 8px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #00b0aa10;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.build_active {

		background: linear-gradient(60deg, rgb(12, 113, 143), #514198, #42e3ff, #00534bee);
		background-size: 1000% 1000%;

		-webkit-animation: AnimationName 8s ease infinite;
		-moz-animation: AnimationName 8s ease infinite;
		-o-animation: AnimationName 8s ease infinite;
		animation: AnimationName 8s ease infinite;
	}

	.menu_build_bh {
		height: 75px;
		border-radius: 8px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #060606;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.build_active_bh {

		background: linear-gradient(60deg, rgb(0, 3, 4), #040307, #87a3a8, #151615ee);
		background-size: 1000% 1000%;

		-webkit-animation: AnimationName 7s ease infinite;
		-moz-animation: AnimationName 7s ease infinite;
		-o-animation: AnimationName 7s ease infinite;
		animation: AnimationName 7s ease infinite;
	}

	.congratulations {
		position: absolute;
		font-size: 5vw;
		user-select: none;
	}

	.sparks_found {
		position: absolute;
		font-size: 5vw;
		user-select: none;
	}

	.like-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.5s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.balance-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.6s infinite;
	}

	.plus-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 1.2s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.3);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.text-electric-location2 {
    background: linear-gradient(129deg, #55f6ff, #76eaff, #090033, #ff0000);
    background-size: 800% 800%;
/*
    -webkit-animation: AnimationName 5.8s ease infinite;
    -moz-animation: AnimationName 5.8s ease infinite;
    -o-animation: AnimationName 5.8s ease infinite;
    animation: AnimationName 5.8s ease infinite;*/
	}

	.text-electric-location1 {
    background: linear-gradient(129deg, #725cd8, #00d9ff, #090033, #ff0000);
    background-size: 800% 800%;
/*
    -webkit-animation: AnimationName 5.8s ease infinite;
    -moz-animation: AnimationName 5.8s ease infinite;
    -o-animation: AnimationName 5.8s ease infinite;
    animation: AnimationName 5.8s ease infinite;*/
	}

	@-webkit-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
	}
	@-moz-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
	}
	@-o-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
	}
	@keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
	}


	.copy-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.3s;
	}

	input[type="text"] {
		background: rgba(0, 0, 0, 0);
		border: none;
		outline: none;
		color: white;
		font-size: 10px;
	}

	.tooltip1 {
		margin-top: 0px;
		font-size: 12px;
		border-radius: 6px;
		border: 1px solid rgb(83, 83, 83);
		background-color: transparent;
		color: #1bffe8ee;
		padding: 3px;
	}

	.tooltip {
		margin-top: 0px;
		font-size: 12px;
		border-radius: 6px;
		border: 1px solid rgb(83, 83, 83);
		background-color: transparent;
		color: #1bffe8ee;
		padding: 3px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}

	.header-text {
    	position: relative;
	    color: #55f6ff;
		font-size: 10px;
	}

    .text-electric-grey {
        font-size: 14px;
		font-family: arial;
		color: lightblue;
	}

	.outer_blue {
		margin: 0px;
		background-color: transparent;
		border: 0px;
		text-shadow: 0 0 8px rgb(0, 179, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

	.text-electric-egg {
		text-shadow: 0 0 5px rgba(255, 255, 192, 0.7),
			0 0 10px rgba(251, 255, 29, 0.968);
		font-family: arial;
		color: hsl(70, 97%, 75%);
		animation: egg-pulse 3.5s infinite;
	}

	@keyframes egg-pulse {
	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(255, 251, 5, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}

	10% {
		text-shadow: 0 0 32px rgba(249, 192, 255, 0.9),
			0 0 15px rgba(201, 65, 255, 0.98);
		color: hsl(294, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(251, 255, 5, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}
	}

	.main1 {
		border-radius: 20px;
		background-color: transparent;
		background-color: transparent;
		height: 600px;
		width: 370px;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
	}

	.main1::-webkit-scrollbar {
		display: none;
	}

</style>
